<div class="container  ">

  <div class="right-container">

    <mat-stepper class="example-stepper" #stepper [selectedIndex]="currentIndex" linear
      [orientation]="stepperOrientation">
      <mat-step [stepControl]="registrationForm" [editable]="!resumeBankForm.value.resId || editable">
        <!-- <mat-step [stepControl]="registrationForm"> -->

        <ng-template matStepLabel>{{"EXTRA.Personal Information"|translate}}</ng-template>
        <ng-template matStepContent>
          <table class="table skeleton" *ngIf="field_loading">
            <tbody>
              <tr *ngFor="let a of [1,2,3,4,5,6]; let i=index;" style="width: 100%;">
                <th *ngFor="let bs of [1,2]; let j=index;" class="skeleton-th">
                  <div [style.width]="random_width.length &&random_width[i] &&random_width[i][j]"
                    class="horizontal-bar"></div>
                </th>
              </tr>
            </tbody>
          </table>
          <form [formGroup]="registrationForm" *ngIf="!field_loading">

            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-1 align-self-center">
                    <div class="row">
                      <!-- <div class="col-md-12">
                          <button class="btn btn-default btn-sm w-100 icr-save-btn new-btn mb-0" (click)="fileInput1.click()"
                            mat-raised-button>
                            {{jobseeker.files && jobseeker.files.length?('RESUME.changeResume' |
                            translate):('RESUME.selectResume' | translate) }}
                          </button>
                          <input type='file' style="display: none;" id="imageUpload1" #fileInput1
                            (change)="fileInputChangedRes($event)" />


                        </div> -->
                      <div class="col-md-12 text-center">
                        <div class="avatar-upload">
                          <!-- <div class="avatar-delete">
                            <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput
                              style="display: none;" (change)="fileInputChanged($event)" />
                            <label for="imageUpload"></label>
                          </div> -->
                          <div class="avatar-capture-camera" [title]="'RESUME.Capture photo by camera'|translate"
                            [ngStyle]="{'justify-content':(resumeObj.profilePicture && resumeObj.profilePicture !='')?'space-around':'flex-start'}">
                            <i class="fa fa-camera pointer camera-icon" *ngIf="false" (click)="setupDevices({
                            isCamShot : true
                          })"></i>
                            <i class="fa fa-eye pointer camera-icon " [title]="'RESUME.view'|translate"
                              *ngIf="resumeObj.profilePicture && resumeObj.profilePicture !=''" (click)="viewAttachments({attachments:[{
                            fileName:resumeObj.profilePicture,
                            'cdnPath':resumeObj.profilePicture
                          }]})"></i>

                            <i class="fa fa-trash orange pointer camera-icon " [title]="'BTN.delete'|translate"
                              *ngIf="resumeObj.profilePicture && resumeObj.profilePicture !='' || uploadedImageUrl"
                              (click)="removeUploadedFile()"></i>

                          </div>
                          <div class="avatar-edit">
                            <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput
                              (change)="fileInputChanged($event)" />
                            <!-- <label for="imageUpload"></label> -->
                          </div>
                          <div class="avatar-preview" [style.height.px]="60 ||(jobseeker.profileHeight -5)"
                            [style.width.px]=" 60|| jobseeker.profileWidth">
                            <span *ngIf="uploadedImageUrl || resumeObj.profilePicture" class="delete-profile">
                              <i class="fa fa-pencil pointer delete-icon" (click)="fileInput.click()">
                              </i>
                              <div class="overlay"></div>
                            </span>

                            <div class="jump" (click)="fileInput.click()" *ngIf="resumeObj.profilePicture"
                              id="imagePreview"
                              [style.backgroundImage]="'url(https://storage.googleapis.com/ezeone/icanrefer/'+resumeObj.profilePicture +')'">
                            </div>
                            <div class="jump" (click)="fileInput.click()" *ngIf="uploadedImageUrl" id="imagePreview"
                              [style.backgroundImage]="'url('+ uploadedImageUrl +')'">
                            </div>
                            <div (click)="fileInput.click()" *ngIf="!resumeObj.profilePicture && !uploadedImageUrl"
                              id="imagePreviewDefault">
                            </div>


                          </div>

                          <!-- <div class="avatar-delete" *ngIf="uploadedImageUrl || resumeObj.profilePicture">
                              <label (click)="removeUploadedFile();fileInput.innerHTML=''"></label>

                            </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-sm-8 ">
                    <tm-multi-select [design_pattern]="3" #search_input [options]="this.country_info.jobTypeList || []"
                      (selected_obj)="preferredJobTypeChanges($event)" [form_group]="registrationForm"
                      form_control="jobType" title_property="title" id_property="jobType" float_label="always"
                      [label]="'Preferred job types' | translate" [data]="registrationForm.value.jobType"
                      [mandatory]="1" [placeholder]="' < - - Select - - > '">
                    </tm-multi-select>
                  </div> -->

                  <div class="col-md-6">
                    <tm-files-v2 [multiple]="0" [resume_parser]="1" [result]="cvAttachments" [design_pattern]="3"
                      (returnFiles)="fileChanged($event)" [extra_control_name]="'cvFileName'" [save_cdnpath]="'cvPath'"
                      [save_filename]="'cvFileName'" [form_group]="registrationForm" [form_control]="'cvPath'"
                      [label]="'Upload your resume'" [accept_file_type]="fileType">
                    </tm-files-v2>
                  </div>

                  <div
                    [class]="field_config_access['RES_skillType'] &&field_config_access['RES_skillType'].fieldClass ? field_config_access['RES_skillType'].fieldClass :'col-md-2'"
                    *ngIf="field_config_access && field_config_access['RES_skillType']">
                    <tm-select [options]="this.country_info.skillTypeMaster||[]" [form_group]="registrationForm"
                      form_control="skillType" title_property="title" id_property="id" float_label="always"
                      [label]=" field_config_access['RES_skillType'].label ||'Skill type' | translate"
                      [data]="registrationForm.value.skillType" [mandatory]="field_config_access['RES_skillType'].validationScriptUI &&
                  field_config_access['RES_skillType'].validationScriptUI.mandatory?1:0"
                      [placeholder]="field_config_access['RES_skillType'].placeholder ||'<- - Select - ->' | translate"
                      [label_overflow]="1">
                    </tm-select>
                  </div>

                  <div
                    [class]="field_config_access['RES_firstName'] &&field_config_access['RES_firstName'].fieldClass ? field_config_access['RES_firstName'].fieldClass :'col-md-6'"
                    [ngStyle]="{'order': field_config_access['RES_firstName'] &&field_config_access['RES_firstName'].fieldSeq}"
                    *ngIf="field_config_access && field_config_access['RES_firstName']">
                    <mat-form-field floatLabel="always">
                      <mat-label> {{ field_config_access['RES_firstName'].label ||'First name' | translate }}
                      </mat-label>
                      <input class="w-93" matInput
                        [placeholder]="field_config_access['RES_firstName'].placeholder ||'Enter First name' | translate"
                        formControlName="firstName" [maxLength]="250">
                      <mat-error *ngIf="this.registrationForm.get('firstName').hasError('required');else pattern ">
                        {{'Field is mandatory' |translate}}

                      </mat-error>
                      <ng-template #pattern>
                        <mat-error *ngIf="registrationForm.get('firstName').hasError('pattern')">
                          {{'Invalid input' | translate}}
                        </mat-error>
                      </ng-template>

                    </mat-form-field>
                  </div>
                  <div
                    [class]="field_config_access['RES_lastName'] &&field_config_access['RES_lastName'].fieldClass ? field_config_access['RES_firstName'].fieldClass :'col-md-6'"
                    [ngStyle]="{'order': field_config_access['RES_lastName'] &&field_config_access['RES_lastName'].fieldSeq}"
                    class="col-md-6" *ngIf="field_config_access && field_config_access['RES_lastName']">
                    <mat-form-field floatLabel="always">
                      <mat-label> {{ field_config_access['RES_lastName'].label ||'Last name' | translate }}</mat-label>
                      <input class="w-93" matInput
                        [placeholder]="field_config_access['RES_lastName'].placeholder || 'Enter last name' | translate "
                        formControlName="lastName" [maxLength]="250">
                      <mat-error *ngIf="registrationForm.get('lastName').hasError('pattern')">
                        {{'Invalid input' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

              </div>
            </div>
            <div class="row  ">

              <div
                [class]="field_config_access['RES_mobileNumber'] &&field_config_access['RES_mobileNumber'].fieldClass ? field_config_access['RES_mobileNumber'].fieldClass :'col-md-6'"
                [ngStyle]="{'order': field_config_access['RES_mobileNumber'] &&field_config_access['RES_mobileNumber'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_mobileNumber']">
                <div class="prefix-control" style="width: 30%;">
                  <tm-select [options]="country_info.countryList||[]" [form_group]="registrationForm"
                    form_control="mobileIsd" title_property="name" id_property="dial_code" float_label="always"
                    [label]=" field_config_access['RES_mobileNumber'].label ||'Mobile number' | translate"
                    (selected_obj)="mobileChange($event,2)" [data]="registrationForm.value.mobileIsd"
                    [placeholder]="'<- - Select - ->' | translate" [mandatory]="1" [label_overflow]="1">
                  </tm-select>
                </div>
                <div class="main-control" style="width: 70%;">
                  <app-phone-number
                    [placeholder]="field_config_access['RES_mobileNumber'].placeholder ||'Enter mobile number'|translate"
                    [form]="registrationForm" controlName="mobileNumber"
                    [data]="this.registrationForm.controls['mobileNumber'].value"
                    [maxLength]="this.registration.mobile_number_length" [disabledDial]="1"
                    [minLength]="this.registration.mobile_number_length ||0" [pattern_desc]="'^[0-9]*$'" [required]="1"
                    [hide_label]="1">
                  </app-phone-number>
                </div>
              </div>
              <div
                [class]="field_config_access['RES_emailId'] &&field_config_access['RES_emailId'].fieldClass ? field_config_access['RES_emailId'].fieldClass :'col-md-6'"
                [ngStyle]="{'order': field_config_access['RES_emailId'] &&field_config_access['RES_emailId'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_emailId']">
                <mat-form-field floatLabel="always">
                  <mat-label>
                    {{field_config_access['RES_emailId'].label || 'Email ID'|translate}}
                  </mat-label>
                  <input matInput
                    [placeholder]=" field_config_access['RES_emailId'].placeholder || 'Enter Email ID'|translate"
                    formControlName="emailId" name="emailId" [maxLength]="100" />
                  <mat-error *ngIf="registrationForm.get('emailId').hasError('pattern');else email_req">
                    {{'Invalid Email ID' | translate}}
                  </mat-error>
                  <ng-template #email_req>
                    <mat-error>
                      {{'Field is mandatory' | translate}}
                    </mat-error>
                  </ng-template>
                </mat-form-field>
              </div>
              <div
                [class]="field_config_access['RES_waMobileNumber'] &&field_config_access['RES_waMobileNumber'].fieldClass ? field_config_access['RES_waMobileNumber'].fieldClass :'col-md-6'"
                [ngStyle]="{'order': field_config_access['RES_waMobileNumber'] &&field_config_access['RES_waMobileNumber'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_waMobileNumber']">
                <div class="prefix-control" style="width: 30%;">
                  <tm-select [options]="country_info.countryList||[]" [form_group]="registrationForm"
                    form_control="waMobileIsd" title_property="name" id_property="dial_code" float_label="always"
                    [label]="field_config_access['RES_waMobileNumber'].label ||'RESUME.waMobileNumber' | translate"
                    [data]="registrationForm.value.waMobileIsd" [placeholder]="'<- - Select - ->' | translate"
                    [disabled]="jobseeker.is_misd_disabled" [width]="218" [label_overflow]="1">
                  </tm-select>
                </div>
                <div class="main-control" style="width: 70%;">
                  <app-phone-number
                    [placeholder]="field_config_access['RES_waMobileNumber'].placeholder ||'RESUME.enterMobileNumber'|translate"
                    [options]="country_info.countryList||[]" [options_data]="registrationForm.value.waMobileIsd"
                    [form]="registrationForm" controlName="waMobileNumber" [label]=" 'RESUME.waMobileNumber' "
                    [data]="this.registrationForm.controls['waMobileNumber'].value"
                    [maxLength]="this.jobseeker.mobile_number_length" [disabledDial]="1"
                    [addFunc]="copyMobileNumberToWARef" [suffix_icon]="'fa-copy'" [suffix_tooltip]="'Same as above'"
                    [minLength]="this.jobseeker.mobile_number_length ||0" [pattern_desc]="'^[0-9]*$'" [hide_label]="1">
                  </app-phone-number>
                </div>
              </div>
              <div
                [class]="field_config_access['RES_presentLocationId'] &&field_config_access['RES_presentLocationId'].fieldClass ? field_config_access['RES_presentLocationId'].fieldClass :'col-md-6'"
                [ngStyle]="{'order': field_config_access['RES_presentLocationId'] &&field_config_access['RES_presentLocationId'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_presentLocationId']">
                <tm-select [options]="timeBasedMaster.cityList||[]" [form_group]="registrationForm"
                  (selected_obj)="presentLocationChanged($event)" form_control="presentLocationId"
                  title_property="title" id_property="id" float_label="always"
                  [label]="field_config_access['RES_presentLocationId'].label ||'RESUME.presentLocation' | translate"
                  [label_action_title]="'Your city not found?'" [label_action_type]='1'
                  [type_to_search]=" field_config_access['RES_presentLocationId'] && field_config_access['RES_presentLocationId'].validationScriptUI && field_config_access['RES_presentLocationId'].validationScriptUI.tabNumber ==99?'Type to search':null"
                  [data]="registrationForm.value.presentLocationId" [design_pattern]="4"
                  [addFunc]="managePresentLocationsRef" [suffix_btn_icon]="'fa-map-marker'"
                  [placeholder]=" field_config_access['RES_presentLocationId'].placeholder || '<- - Select - ->' | translate">
                </tm-select>
                <!-- <mat-form-field floatLabel="always">
                  <mat-label>{{'Location'|translate}}
                  </mat-label>
                  <input ngInit [func]="getPlaceAutocompleteRefPresent" #addresstextPresent formControlName="address"
                    type="search" (input)="setTimer()" matInput placeholder="{{'Search location'|translate}}"
                    style="width: 100%;" />
                  <i style="font-size: 1.5rem;" [matTooltip]="'REGISTRATION.selectFromMap' |translate"
                    (click)="findLocation()" class="fa orange pointer fa-map-marker mr-1" matSuffix></i>
                </mat-form-field> -->
              </div>
              <div
                [class]="field_config_access['RES_jobType'] &&field_config_access['RES_jobType'].fieldClass ? field_config_access['RES_jobType'].fieldClass :'col-md-12'"
                [ngStyle]="{'order': field_config_access['RES_jobType'] &&field_config_access['RES_jobType'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_jobType'] " style="font-size: 10px !important;">
                <tm-multi-checkbox class="preferredCheck" [options]="this.country_info.jobTypeList || []"
                  [title_property]="'title'"
                  [label]="field_config_access['RES_jobType'].label ||'Preferred job types' | translate"
                  (change)="preferredJobTypeChanges($event)" [id_property]="'jobType'" [form_group]="registrationForm"
                  [form_control]="'jobType'" [data]="registrationForm.value.jobType">
                </tm-multi-checkbox>
              </div>

              <!-- <div class="col-md-3" *ngIf="!duplicateChecked || !this.resumeBankForm.value.resId">
                    <button class="float-right" style="background: orange; color:white" mat-raised-button
                      (click)="checkDuplicate()">
                      <span style="text-decoration: none;">{{'REGISTRATION.checkForDuplicate' |translate}}</span>
                    </button>
                  </div> -->

              <ng-container>
                <!-- *ngIf="this.companySettingsSettings &&  (!this.companySettingsSettings.enableEmailOtpForJS && !this.companySettingsSettings.enableSmsOtpForJS)" -->
                <div class="col-md-6"
                  [class]="field_config_access['RES_password'] &&field_config_access['RES_password'].fieldClass ? field_config_access['RES_password'].fieldClass :'col-md-6'"
                  [ngStyle]="{'order': field_config_access['RES_password'] &&field_config_access['RES_password'].fieldSeq}"
                  *ngIf="!this.resId && field_config_access && field_config_access['RES_password'] "
                  style="font-size: 10px !important;">
                  <app-mask-password [form_group]="registrationForm" [form_control]="'password'" [enable_mismatch]="1"
                    [validationScript]="field_config_access?.['RES_password']?.validationScriptUI"
                    [placeholder]="field_config_access['RES_password']?.placeholder||'Enter password' | translate"
                    [mandatory]="field_config_access?.['RES_password']?.validationScriptUI?.mandatory ? true : false"
                    [label]="field_config_access['RES_password'].label||'Password'|translate">
                  </app-mask-password>
                  <!-- <app-mask-password [form_group]="registrationForm" [form_control]="'password'" [enable_mismatch]="1"
                    [validationScript]="passValidation"
                    [placeholder]="field_config_access['RES_password'].placeholder||'Enter password' | translate"
                    [design_pattern]="2"
                    [hint]="field_config_access?.['RES_password']?.validationScriptUI?.instructionText"
                    [mandatory]="field_config_access?.['RES_password']?.validationScriptUI?.mandatory ? true : false"
                    [label]="field_config_access['RES_password'].label||'Password'|translate">
                  </app-mask-password> -->
                  <!-- <mat-form-field floatLabel="always" class="label-overflow">
                    <mat-label>
                      Enter a 6 character password with 1 or more special characters and verify it again
                    </mat-label>
                    <input matInput [type]="field_text_type ? 'text' : 'password'" formControlName="password"
                      maxlength="30" [placeholder]="'Enter password' | translate" autocomplete="new-password" matInput />
                    <i class="pointer fa" matSuffix (click)="field_text_type= !field_text_type" [ngClass]="{
                            'fa-eye-slash': !field_text_type,
                            'fa-eye': field_text_type
                          }"></i>
                    <mat-error *ngIf="registrationForm.controls.password &&registrationForm.controls.password.errors">

                      <div ngClass="fval.password.errors.required"
                        *ngIf="registrationForm.controls.password.errors.required">
                        {{'EMPLOYER.password_is_required' | translate}}
                      </div>
                      <div *ngIf="registrationForm.controls.password.errors.minlength else pattern">
                        {{'EMPLOYER.password_must_be_at_least_6_characters' | translate}}
                      </div>
                      <ng-template #pattern>
                        <div *ngIf="registrationForm.controls.password.errors?.pattern">
                          {{"ERROR.password_input_invalid" |translate}}
                        </div>
                      </ng-template>

                    </mat-error>
                  </mat-form-field> -->

                </div>

                <div class="col-md-6"
                  [class]="field_config_access['RES_confirmPassword'] &&field_config_access['RES_confirmPassword'].fieldClass ? field_config_access['RES_confirmPassword'].fieldClass :'col-md-6'"
                  [ngStyle]="{'order': field_config_access['RES_confirmPassword'] &&field_config_access['RES_confirmPassword'].fieldSeq}"
                  *ngIf="!this.resId && field_config_access && (field_config_access['RES_confirmPassword'] || field_config_access['RES_password']) "
                  style="font-size: 10px !important;">
                  <app-mask-password [form_group]="registrationForm" [form_control]="'confirmPassword'"
                    [enable_mismatch]="1" [mismatch_data]="registrationForm.value.password"
                    [placeholder]="'EMPLOYER.re-enter_password' | translate"
                    [label]="field_config_access['RES_confirmPassword']?.label||'Confirm Password'|translate">
                  </app-mask-password>
                  <!-- <mat-form-field floatLabel="always">
                    <mat-label>
                    </mat-label>
                    <input matInput [type]="password_field_text_type ? 'text' : 'password'"
                      formControlName="confirmPassword" maxlength="30"
                      [placeholder]="'EMPLOYER.re-enter_password' | translate" appConfirmEqualValidator='password' />
                    <i matSuffix class=" pointer fa" (click)="password_field_text_type =!password_field_text_type"
                      [ngClass]="{
                            'fa-eye-slash': !password_field_text_type,
                            'fa-eye': password_field_text_type
                          }"></i>
                    <mat-error
                      *ngIf="registrationForm.controls.confirmPassword &&registrationForm.controls.confirmPassword.errors">
                      <div *ngIf="registrationForm.controls.confirmPassword.errors.required">
                        {{'EMPLOYER.re-enter_password_required' | translate}}
                      </div>
                      <div *ngIf="registrationForm.controls.confirmPassword.errors.minlength">
                        {{'EMPLOYER.password_must_be_at_least_6_characters' | translate}}
                      </div>
                      <div *ngIf="registrationForm.controls.confirmPassword.errors?.pattern">
                        {{"ERROR.password_input_invalid" |translate}}
                      </div>
                      <div *ngIf="registrationForm.controls.confirmPassword.errors?.notEqual">
                        {{'EMPLOYER.password_mismatch' | translate}}
                      </div>
                    </mat-error>
                  </mat-form-field> -->
                </div>
              </ng-container>


            </div>
            <div class="row">

              <div class="col-md-12 mt-3 text-right footers">
                <app-tm-captch *ngIf="field_config_access && field_config_access['RES_captcha'] && !resId"
                  (validCaptch)="verifyCaptch($event)"></app-tm-captch>
                <div class="ml-auto">
                  <button style="min-width: 100px;" *ngIf="!resId" (click)="register()"
                    class="blob-btn  btn  btn-sm  mx-1 register-btn tallite-action" type="submit">
                    {{ 'Register' | translate }}
                    <span class="blob-btn__inner">
                      <span class="blob-btn__blobs">
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                      </span>
                    </span>
                  </button>
                  <button style="min-width: 100px;" *ngIf="resId" (click)="nextStep(1)"
                    class="blob-btn  btn  btn-sm  mx-1 tallite-action" type="submit">
                    {{ 'Next' | translate }}
                    <span class="blob-btn__inner">
                      <span class="blob-btn__blobs">
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                      </span>
                    </span>
                  </button>
                </div>

              </div>
            </div>
          </form>
        </ng-template>

      </mat-step>
      <mat-step [editable]="resumeBankForm.value.resId" [stepControl]="secondTabFormGroup">
        <!-- <mat-step [stepControl]="resumeBankForm"> -->
        <ng-template matStepLabel>{{'EXTRA.Preferences, Skills and Education'|translate}}</ng-template>
        <ng-template matStepContent>
          <form [formGroup]="resumeBankForm">
            <div
              [class]="field_config_access['RES_keySkills'] &&field_config_access['RES_keySkills'].fieldClass ? field_config_access['RES_keySkills'].fieldClass :'row'"
              *ngIf="field_config_access && field_config_access['RES_keySkills']"
              [ngStyle]="{'order': field_config_access['RES_keySkills'] &&field_config_access['RES_keySkills'].fieldSeq}">
              <!-- Preferred Job Type -->


              <div
                [class]="field_config_access['RES_keySkills'] &&field_config_access['RES_keySkills'].fieldClass ? field_config_access['RES_keySkills'].fieldClass :'col-md-12'"
                *ngIf="field_config_access && field_config_access['RES_keySkills']">
                <tm-multi-select [options]="this.key_skills_masters.skills || []" [enable_virtual_scroll]="1"
                  [form_group]="resumeBankForm" form_control="keySkills" title_property="title" id_property="skillCode"
                  float_label="always" (selected_obj)="keySkillsChanged($event)"
                  [label]="field_config_access['RES_keySkills'].label ||'RESUME.selectKeySkills' | translate"
                  [data]="resumeBankForm.value.keySkills" [suffix_btn_icon]="'fa-ellipsis-h'"
                  [placeholder]="field_config_access['RES_keySkills'].placeholder ||'< - - Select - - >' | translate"
                  [addFunc]="addSkillRef" [mandatory]="1" (fetchEntries)="loadSkills($event)"
                  [enable_virtual_scroll]="1" [master_obj]="jobseeker.skillMasters"
                  [no_data_found_message]="this.jobseeker.no_data_found_message"
                  [mandatory]="this.resumeBankForm.value.resumeStatusCode==1?1:0">
                </tm-multi-select>
              </div>
              <!-- [addFunc]='openSkillRankingRef'
                    [suffix_btn_icon]="'fa-star'" [suffix_btn_label]="'RESUME.Skill Ranking' |translate" -->

              <!-- CV Type -->
              <!-- <div class="col-sm-3 ">
                  <mat-label ngClass="global_lang" style="display: block;" class="attch mb-1">
                    {{ 'RESUME.cvType' | translate }}
                  </mat-label>
                  <mat-button-toggle-group #group="matButtonToggleGroup" [value]="1" formControlName="cvType"
                    (change)="onValChange(group.value,1)">
                    <mat-button-toggle [value]="f.code" aria-label="f.title"
                      *ngFor="let f of masters.cvTypeList ||[]; let i = index">
                      {{f.title |translate }}
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div> -->

              <!-- CV Source -->
              <!-- <div class="col-sm-3 ">
                  <mat-label ngClass="global_lang" style="display: block;" class="attch mb-1">
                    {{ 'RESUME.cvSource' | translate }}
                  </mat-label>
                  <mat-button-toggle-group #group="matButtonToggleGroup" [value]="1" formControlName="cvSourceType">
                    <mat-button-toggle [value]="f.code" aria-label="f.title"
                      *ngFor="let f of masters.cvSourceList ||[]; let i = index">
                      {{f.title |translate }}
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div> -->

              <!-- Status -->
              <!-- <div class="col-sm-2 form-group ">
                  <tm-select [options]="masters.resumeStatusList||[]" [form_group]="resumeBankForm"
                    form_control="resumeStatusCode" title_property="title" id_property="resumeStatusCode"
                    float_label="always" [label]="'RESUME.status' | translate" (selected_obj)="onValChange($event)"
                    [data]="resumeBankForm.value.resumeStatusCode" [placeholder]="' < - - Select - - > ' | translate"
                    [mandatory]="1">
                  </tm-select>
                </div> -->
              <!-- <div class="col-sm-12 align-self-center form-group" *ngIf="resumeBankForm.value.resumeStatusCode == 2">
                  <mat-radio-group [(ngModel)]="interested" #radioGroup="matRadioGroup"
                    (change)="interestedClick(interested)" [ngModelOptions]="{standalone: true}">
                    <mat-radio-button [value]="1">
                      {{'RESUME.3Months' |translate}}&nbsp;
                    </mat-radio-button>
                    <mat-radio-button [value]="2">
                      {{'RESUME.6Months' |translate}}&nbsp;
                    </mat-radio-button>
                    <mat-radio-button [value]="3">
                      {{'RESUME.1Year' |translate}}&nbsp;</mat-radio-button>
                    <mat-radio-button [value]="4">
                      {{'RESUME.specificDate' |translate}}&nbsp;</mat-radio-button>
                    <mat-form-field floatLabel="never"
                      style="width: 150px;position: absolute;top:-20px;margin-left : 16px"
                      *ngIf="interested == 4 && resumeBankForm.value.resumeStatusCode == 2">
                      <input matInput [matDatepicker]="picker2" formControlName="interestedAfterDate"
                        placeholder="{{'RESUME.interestedLater'|translate}}" readonly (click)="picker2.open()">
                      <mat-datepicker-toggle matSuffix [for]="picker2">
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker2 startView="year" disabled="false">
                      </mat-datepicker>
                    </mat-form-field>
                  </mat-radio-group>

                </div> -->


            </div>
            <div class="row"
              [ngStyle]="{'order': field_config_access['RES_education'] &&field_config_access['RES_education'].fieldSeq}"
              *ngIf="field_config_access && field_config_access['RES_education'] ">
              <div class="col-md-12 form-group table-responsive"
                *ngIf="this.field_config_access && this.field_config_access['RES_education']">
                <div class="multi-select-container education-controls">
                  <form [formGroup]="educationForm" style="padding: 1px;">
                    <p>
                      <mat-label class="col-form-label">
                        {{'Education'}}
                      </mat-label>
                      <mat-radio-group formControlName="educationLevel">
                        <mat-radio-button [value]="item.id" *ngFor="let item of masters.educationLevelList">
                          {{item.title}} </mat-radio-button>
                      </mat-radio-group>
                    </p>


                    <div class="row form-group "
                      [ngClass]="{'bb-gainsboro-1px':educationForm.value.educationLevel==7 ||educationForm.value.educationLevel==8 }">
                      <div class="col-md-12 form-group">
                        <mat-label class="col-form-label">
                          {{6 |DynamicPipe :masters.educationLevelList : 'id':'title' }}
                        </mat-label>
                      </div>
                      <div class="col-md-2"
                        *ngIf="this.field_config_access && this.field_config_access['RES_educationType']">
                        <tm-select [form_group]="educationForm" [form_control]="'educationType'"
                          [appearance]="'outline'" [options]="masters.educationTypeList"
                          [label]="  this.field_config_access['RES_educationType'].label || 'Education Type'"
                          [mandatory]="1" [data]="educationForm.value.educationType"
                          [placeholder]="this.field_config_access['RES_educationType'].placeholder ||'Select education type'">
                        </tm-select>
                      </div>
                      <div class="col-md-3"
                        *ngIf="this.field_config_access && this.field_config_access['RES_educationCode']">
                        <tm-select [appearance]="'outline'" [options]="educationLevel1||[]" [form_group]="educationForm"
                          form_control="educationCode" title_property="title" id_property="educationCode"
                          float_label="always"
                          [label]=" this.field_config_access['RES_educationCode'].label ||'RESUME.education' | translate"
                          [data]="educationForm.value.educationCode"
                          [placeholder]=" this.field_config_access['RES_educationCode'].placeholder || '  Select education '"
                          (selected_obj)="changeEducation($event)">
                        </tm-select>
                      </div>
                      <div class="col-md-4"
                        *ngIf="this.field_config_access && this.field_config_access['RES_specializationCode']">
                        <tm-select [options]="masters.specializationList||[]" [form_group]="educationForm"
                          [appearance]="'outline'" (selected_obj)="specialicationChanged($event)"
                          form_control="specializationCode" title_property="title" id_property="specializationCode"
                          float_label="always"
                          [label]=" this.field_config_access['RES_specializationCode'].label ||'RESUME.specialization' | translate"
                          [data]="educationForm.value.specializationCode"
                          [disabled]="current_education.noSpecialization"
                          [mandatory]="current_education.isSpecialization "
                          [placeholder]="this.field_config_access['RES_specializationCode'].placeholder ||'Select specialization'">
                        </tm-select>
                      </div>
                      <div class="col-md-3"
                        *ngIf="this.field_config_access && this.field_config_access['RES_percentage']">
                        <div class="prefix-control" style="width: 60%;">
                          <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label style="text-align: right;">
                              {{this.field_config_access['RES_percentage'].label}}
                            </mat-label>
                            <input min="1" max="100" type="number" class="w-93" matInput
                              [required]="current_education && current_education.isPercentage? true:false"
                              [placeholder]="this.field_config_access['RES_percentage'].placeholder || 'Score' | translate "
                              formControlName="percentage" [min]="1" [max]="100">

                            <mat-error *ngIf="educationForm.get('percentage').hasError('required');else permin ">
                              {{'ERROR.field_is_mandatory'|translate}}
                            </mat-error>
                            <ng-template #permin>
                              <mat-error *ngIf="educationForm.get('percentage').hasError('min');else permax ">
                                {{ 'ERROR.min_value' |translate }} {{current_percentage_type &&
                                current_percentage_type.minVal}}
                              </mat-error>
                            </ng-template>
                            <ng-template #permax>
                              <mat-error *ngIf="educationForm.get('percentage').hasError('max');else perPattern">
                                {{"ERROR.max_value" |translate}} {{current_percentage_type &&
                                current_percentage_type.maxVal}}
                              </mat-error>
                            </ng-template>
                            <ng-template #perPattern>
                              <mat-error *ngIf="educationForm.get('percentage').hasError('pattern')">
                                {{'ERROR.max_value'|translate}} 100
                              </mat-error>
                            </ng-template>


                          </mat-form-field>
                        </div>
                        <div class="main-control" style="width: 40%;"
                          *ngIf="this.field_config_access && this.field_config_access['RES_percentageType']">
                          <tm-select [form_group]="educationForm" [form_control]="'percentageType'"
                            (selected_obj)="percentageTypeChanged($event,6)" [hide_label]="1" [appearance]="'outline'"
                            [options]="masters.educationScoreTypeList"
                            [label]="this.field_config_access['RES_percentageType'].label ||'Education level'"
                            [mandatory]="1" [data]="educationForm.value.percentageType"
                            [placeholder]="this.field_config_access['RES_percentageType'].placeholder ||'Select education level'">
                          </tm-select>
                        </div>

                      </div>
                      <div class="col-md-2"
                        *ngIf="this.field_config_access && this.field_config_access['RES_passingMN']">
                        <tm-month-year [form]="educationForm" [controlName]="'passingMN'" [appearance]="'outline'"
                          [float_label]="'always'" [value]="educationForm.value.passingMN"
                          [label]="this.field_config_access['RES_passingMN'].label"
                          [placeholder]="this.field_config_access['RES_passingMN'].placeholder ||'Passing year'">
                        </tm-month-year>
                      </div>

                      <div class="col-md-4"
                        *ngIf="this.field_config_access && this.field_config_access['RES_universityCode']">
                        <tm-select [options]="this.education_masters.universityList1||[]" [form_group]="educationForm"
                          [auto_addition]="1" [enable_virtual_scroll]="1"
                          [master_obj]="education_masters.universityMaster" (fetchEntries)="getUniversityList($event,1)"
                          [donot_autoselect]="1" [auto_data]="educationForm.value.university"
                          [auto_form_control]="'university'" [appearance]="'outline'" form_control="universityCode"
                          title_property="title" id_property="universityCode" float_label="always"
                          [label]=" this.field_config_access['RES_universityCode'].label ||'University/School' | translate"
                          [data]="educationForm.value.universityCode"
                          [placeholder]="this.field_config_access['RES_universityCode'].placeholder ||'University' | translate">
                        </tm-select>
                      </div>
                      <div class="col-md-4"
                        *ngIf="this.field_config_access && this.field_config_access['RES_collegeId']">
                        <tm-select [form_group]="educationForm" [options]="education_masters.collegeList1||[]"
                          [enable_virtual_scroll]="1" [master_obj]="education_masters.collegeMaster"
                          [donot_autoselect]="1" (fetchEntries)="getCollegeList($event,1)" [auto_addition]=" 1"
                          [auto_data]="educationForm.value.collegeName" [auto_form_control]="'collegeName'"
                          [appearance]="'outline'" form_control="collegeId" title_property="title" id_property="id"
                          float_label="always"
                          [label]=" this.field_config_access['RES_collegeId'].label ||'University/School' | translate"
                          [data]="educationForm.value.collegeId"
                          [placeholder]="this.field_config_access['RES_collegeId'].placeholder ||'Name of School/College' | translate">
                        </tm-select>
                        <mat-form-field appearance="outline" floatLabel="always" *ngIf="false">
                          <mat-label>
                            <!-- {{ 'Score' | translate }} -->
                          </mat-label>
                          <input min="1" max="100" class="w-93" matInput
                            placeholder="{{ 'Name of School/College' | translate }}" formControlName="collegeName">
                          <!-- <mat-error *ngIf="educationForm.get('collegeName').hasError('pattern')">
                                                    {{'ERROR.max_value'|translate}} 100
                                                </mat-error> -->
                        </mat-form-field>
                      </div>


                    </div>
                    <form [formGroup]="educationForm2" *ngIf="educationForm.value.educationLevel!=6">
                      <div class="row form-group "
                        [ngClass]="{'bb-gainsboro-1px':educationForm.value.educationLevel==8 }">
                        <div class="col-md-12 form-group">
                          <mat-label class="col-form-label">
                            {{7 |DynamicPipe :masters.educationLevelList : 'id':'title' }}
                          </mat-label>
                        </div>
                        <div class="col-md-2"
                          *ngIf="this.field_config_access && this.field_config_access['RES_educationType']">
                          <tm-select [form_group]="educationForm2" [form_control]="'educationType'"
                            [appearance]="'outline'" [options]="masters.educationTypeList"
                            [label]="this.field_config_access['RES_educationType'].label ||'Education Type'"
                            [mandatory]="1" [data]="educationForm2.value.educationType"
                            [placeholder]="this.field_config_access['RES_educationType'].placeholder ||'Select education type'">
                          </tm-select>
                        </div>

                        <div class="col-md-3"
                          *ngIf="this.field_config_access && this.field_config_access['RES_educationCode']">
                          <tm-select [appearance]="'outline'" [options]="educationLevel2||[]"
                            [form_group]="educationForm2" form_control="educationCode" title_property="title"
                            id_property="educationCode" float_label="always"
                            [label]="this.field_config_access['RES_educationCode'].label ||'RESUME.education' | translate"
                            [data]="educationForm2.value.educationCode"
                            [placeholder]="this.field_config_access['RES_educationCode'].placeholder || '  Select education '"
                            (selected_obj)="changeEducation($event,2)">
                          </tm-select>
                        </div>
                        <div class="col-md-4"
                          *ngIf="this.field_config_access && this.field_config_access['RES_specializationCode']">
                          <tm-select [options]="masters.specializationList||[]" [form_group]="educationForm2"
                            [appearance]="'outline'" (selected_obj)="specialicationChanged($event,2)"
                            form_control="specializationCode" title_property="title" id_property="specializationCode"
                            float_label="always"
                            [label]="this.field_config_access['RES_specializationCode'].label ||'RESUME.specialization' | translate"
                            [data]="educationForm2.value.specializationCode"
                            [disabled]="current_education2.noSpecialization"
                            [mandatory]="current_education2.isSpecialization "
                            [placeholder]="this.field_config_access['RES_specializationCode'].placeholder ||'Select specialization'">
                          </tm-select>
                        </div>
                        <div class="col-md-3"
                          *ngIf="this.field_config_access && this.field_config_access['RES_percentage']">
                          <div class="prefix-control" style="width: 60%;">
                            <mat-form-field appearance="outline" floatLabel="always">
                              <mat-label style="text-align: right;">
                                {{ this.field_config_access['RES_percentage'].label || 'Score' | translate
                                }}
                              </mat-label>
                              <input min="1" max="100" type="number" class="w-93" matInput
                                [required]="current_education2 && current_education2.isPercentage? true:false"
                                [placeholder]=" this.field_config_access['RES_percentage'].placeholder ||  'Score' | translate "
                                formControlName="percentage" [min]="1" [max]="100">
                              <mat-error *ngIf="educationForm2.get('percentage').hasError('required');else per1min ">
                                {{'ERROR.field_is_mandatory'|translate}}
                              </mat-error>
                              <ng-template #per1min>
                                <mat-error *ngIf="educationForm2.get('percentage').hasError('min');else per1max ">
                                  {{ 'ERROR.min_value' |translate }} {{current_percentage_type2 &&
                                  current_percentage_type2.minVal}}
                                </mat-error>
                              </ng-template>
                              <ng-template #per1max>
                                <mat-error *ngIf="educationForm2.get('percentage').hasError('max');else per1Pattern">
                                  {{"ERROR.max_value" |translate}} {{current_percentage_type2 &&
                                  current_percentage_type2.maxVal}}
                                </mat-error>
                              </ng-template>
                              <ng-template #per1Pattern>
                                <mat-error *ngIf="educationForm2.get('percentage').hasError('pattern')">
                                  {{'ERROR.max_value'|translate}} 100
                                </mat-error>
                              </ng-template>
                            </mat-form-field>
                          </div>
                          <div class="main-control" style="width: 40%;"
                            *ngIf="this.field_config_access && this.field_config_access['RES_percentageType']">
                            <tm-select [form_group]="educationForm2" [form_control]="'percentageType'" [hide_label]="1"
                              [appearance]="'outline'" [options]="masters.educationScoreTypeList"
                              (selected_obj)="percentageTypeChanged($event,7)"
                              [label]=" this.field_config_access['RES_percentageType'].label|| 'Education level'"
                              [mandatory]="1" [data]="educationForm2.value.percentageType"
                              [placeholder]="this.field_config_access['RES_percentageType'].placeholder ||'Select education level'">
                            </tm-select>
                          </div>

                        </div>
                        <div class="col-md-2"
                          *ngIf="this.field_config_access && this.field_config_access['RES_passingMN']">
                          <tm-month-year [form]="educationForm2" [controlName]="'passingMN'" [appearance]="'outline'"
                            [float_label]="'always'" [label]="this.field_config_access['RES_passingMN'].label"
                            [value]="educationForm2.value.passingMN"
                            [placeholder]="this.field_config_access['RES_passingMN'].placeholder ||'Passing year'">
                          </tm-month-year>
                        </div>

                        <div class="col-md-4"
                          *ngIf="this.field_config_access && this.field_config_access['RES_universityCode']">
                          <tm-select [options]="this.education_masters.universityList2||[]"
                            [form_group]="educationForm2" [auto_addition]="1"
                            [auto_data]="educationForm2.value.university" [donot_autoselect]="1"
                            [enable_virtual_scroll]="1" [master_obj]="education_masters.universityMaster"
                            (fetchEntries)="getUniversityList($event,2)" [auto_form_control]="'university'"
                            [appearance]="'outline'" form_control="universityCode" title_property="title"
                            id_property="universityCode" float_label="always"
                            [label]="this.field_config_access['RES_universityCode'].label ||'University/School' | translate"
                            [data]="educationForm2.value.universityCode"
                            [placeholder]="this.field_config_access['RES_universityCode'].placeholder ||'University' | translate">
                          </tm-select>
                        </div>
                        <div class="col-md-4"
                          *ngIf="this.field_config_access && this.field_config_access['RES_collegeId']">
                          <tm-select [options]="education_masters.collegeList2||[]" [enable_virtual_scroll]="1"
                            [master_obj]="education_masters.collegeMaster" (fetchEntries)="getCollegeList($event,2)"
                            [form_group]="educationForm2" [auto_addition]="1" [donot_autoselect]="1"
                            [auto_data]="educationForm2.value.collegeName" [auto_form_control]="'collegeName'"
                            [appearance]="'outline'" form_control="collegeId" title_property="title" id_property="id"
                            float_label="always"
                            [label]="this.field_config_access['RES_collegeId'].label ||'University/School' | translate"
                            [data]="educationForm2.value.collegeId"
                            [placeholder]="this.field_config_access['RES_collegeId'].placeholder ||'Name of School/College' | translate">
                          </tm-select>
                        </div>

                      </div>
                    </form>
                    <form [formGroup]="educationForm3"
                      *ngIf="educationForm.value.educationLevel!=6 &&educationForm.value.educationLevel!=7">
                      <div class="row ">
                        <div class="col-md-12 form-group">
                          <mat-label class="col-form-label">
                            {{8 |DynamicPipe :masters.educationLevelList : 'id':'title' }}
                          </mat-label>
                        </div>
                        <div class="col-md-2"
                          *ngIf="this.field_config_access && this.field_config_access['RES_educationType']">
                          <tm-select [form_group]="educationForm3" [form_control]="'educationType'"
                            [appearance]="'outline'" [options]="masters.educationTypeList"
                            [label]="this.field_config_access['RES_educationType'].label ||'Education Type'"
                            [mandatory]="1" [data]="educationForm3.value.educationType"
                            [placeholder]="this.field_config_access['RES_educationType'].placeholder ||'Select education type'">
                          </tm-select>
                        </div>

                        <div class="col-md-3"
                          *ngIf="this.field_config_access && this.field_config_access['RES_educationCode']">
                          <tm-select [appearance]="'outline'" [options]="educationLevel3||[]"
                            [form_group]="educationForm3" form_control="educationCode" title_property="title"
                            id_property="educationCode" float_label="always"
                            [label]="this.field_config_access['RES_educationCode'].label ||'RESUME.education' | translate"
                            [data]="educationForm3.value.educationCode"
                            [placeholder]=" this.field_config_access['RES_educationCode'].placeholder ||'  Select education '"
                            (selected_obj)="changeEducation($event,3)">
                          </tm-select>
                        </div>
                        <div class="col-md-4"
                          *ngIf="this.field_config_access && this.field_config_access['RES_specializationCode']">
                          <tm-select [options]="masters.specializationList||[]" [form_group]="educationForm3"
                            [appearance]="'outline'" (selected_obj)="specialicationChanged($event,3)"
                            form_control="specializationCode" title_property="title" id_property="specializationCode"
                            float_label="always"
                            [label]=" this.field_config_access['RES_specializationCode'].label ||'RESUME.specialization' | translate"
                            [data]="educationForm3.value.specializationCode"
                            [disabled]="current_education3.noSpecialization"
                            [mandatory]="current_education3.isSpecialization "
                            [placeholder]=" this.field_config_access['RES_specializationCode'].placeholder ||'Select specialization'">
                          </tm-select>
                        </div>
                        <div class="col-md-3"
                          *ngIf="this.field_config_access && this.field_config_access['RES_percentage']">
                          <div class="prefix-control" style="width: 60%;">
                            <mat-form-field appearance="outline" floatLabel="always">
                              <mat-label style="text-align: right;">
                                {{ this.field_config_access['RES_percentage'].label ||'Score' | translate }}
                              </mat-label>
                              <input min="1" max="100" type="number" class="w-93" matInput
                                [required]="current_education3 && current_education3.isPercentage? true:false"
                                [placeholder]="this.field_config_access['RES_percentage'].placeholder || 'Score' | translate "
                                formControlName="percentage" [min]="1" [max]="100">
                              <mat-error *ngIf="educationForm3.get('percentage').hasError('required');else per3min ">
                                {{'ERROR.field_is_mandatory'|translate}}
                              </mat-error>
                              <ng-template #per3min>
                                <mat-error *ngIf="educationForm3.get('percentage').hasError('min');else per3max ">
                                  {{ 'ERROR.min_value' |translate }} {{current_percentage_type3 &&
                                  current_percentage_type3.minVal}}
                                </mat-error>
                              </ng-template>
                              <ng-template #per3max>
                                <mat-error *ngIf="educationForm3.get('percentage').hasError('max');else per3Pattern">
                                  {{"ERROR.max_value" |translate}} {{current_percentage_type3 &&
                                  current_percentage_type3.maxVal}}
                                </mat-error>
                              </ng-template>
                              <ng-template #per3Pattern>
                                <mat-error *ngIf="educationForm3.get('percentage').hasError('pattern')">
                                  {{'ERROR.max_value'|translate}} 100
                                </mat-error>
                              </ng-template>
                            </mat-form-field>
                          </div>
                          <div class="main-control" style="width: 40%;"
                            *ngIf="this.field_config_access && this.field_config_access['RES_percentageType']">
                            <tm-select [form_group]="educationForm3" [form_control]="'percentageType'" [hide_label]="1"
                              [appearance]="'outline'" [options]="masters.educationScoreTypeList"
                              (selected_obj)="percentageTypeChanged($event,8)"
                              [label]="this.field_config_access['RES_percentageType'].label ||'Education level'"
                              [mandatory]="1" [data]="educationForm3.value.percentageType"
                              [placeholder]="this.field_config_access['RES_percentageType'].placeholder ||'Select education level'">
                            </tm-select>
                          </div>

                        </div>
                        <div class="col-md-2"
                          *ngIf="this.field_config_access && this.field_config_access['RES_passingMN']">
                          <tm-month-year [form]="educationForm3" [controlName]="'passingMN'"
                            [label]="this.field_config_access['RES_passingMN'].label" [appearance]="'outline'"
                            [float_label]="'always'" [value]="educationForm3.value.passingMN"
                            [placeholder]=" this.field_config_access['RES_passingMN'].placeholder ||'Passing year'">
                          </tm-month-year>
                        </div>

                        <div class="col-md-4"
                          *ngIf="this.field_config_access && this.field_config_access['RES_universityCode']">
                          <tm-select [options]="this.education_masters.universityList3||[]"
                            [form_group]="educationForm3" [auto_addition]="1"
                            [auto_data]="educationForm3.value.university" [auto_form_control]="'university'"
                            [appearance]="'outline'" form_control="universityCode" title_property="title"
                            id_property="universityCode" float_label="always"
                            [label]=" this.field_config_access['RES_universityCode'].label ||'University/School' | translate"
                            [data]="educationForm3.value.universityCode" [enable_virtual_scroll]="1"
                            [master_obj]="education_masters.universityMaster"
                            (fetchEntries)="getUniversityList($event,3)" [donot_autoselect]="1"
                            [placeholder]="this.field_config_access['RES_universityCode'].placeholder ||'University' | translate">
                          </tm-select>
                        </div>
                        <div class="col-md-4"
                          *ngIf="this.field_config_access && this.field_config_access['RES_collegeId']">
                          <tm-select [options]="education_masters.collegeList3||[]" [enable_virtual_scroll]="1"
                            [master_obj]="education_masters.collegeMaster" (fetchEntries)="getCollegeList($event,3)"
                            [form_group]="educationForm3" [auto_addition]="1" [donot_autoselect]="1"
                            [auto_data]="educationForm3.value.collegeName" [auto_form_control]="'collegeName'"
                            [appearance]="'outline'" form_control="collegeId" title_property="title" id_property="id"
                            float_label="always"
                            [label]=" this.field_config_access['RES_collegeId'].label ||'University/School' | translate"
                            [data]="educationForm3.value.collegeId"
                            [placeholder]="this.field_config_access['RES_collegeId'].placeholder ||'Name of School/College' | translate">
                          </tm-select>
                        </div>



                      </div>
                    </form>
                  </form>
                </div>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-md-12 form-group">
                <tm-education [label]="'Education'" [form_group]="resumeBankForm" [form_control]="'education'"
                  [data]="resumeBankForm.value.education" [masters]="masters"></tm-education>
              </div>
            </div> -->

            <div class="row form-group">
              <div
                [class]="field_config_access['RES_anyKeywords'] &&field_config_access['RES_anyKeywords'].fieldClass ? field_config_access['RES_anyKeywords'].fieldClass :'col-lg-12'"
                [ngStyle]="{'order': field_config_access['RES_anyKeywords'] &&field_config_access['RES_anyKeywords'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_anyKeywords'] ">
                <mat-form-field floatLabel="always">
                  <mat-label>
                    {{ field_config_access['RES_anyKeywords'].label ||'RESUME.keywordsOrSkillsToRecogniseJobseeker' |
                    translate }}
                  </mat-label>
                  <input class="w-93" matInput formControlName="anyKeywords"
                    [placeholder]=" field_config_access['RES_anyKeywords'].placeholder || 'RESUME.enterKeywordsOrSkillsToRecogniseJobseeker' | translate ">
                </mat-form-field>
              </div>

              <div
                [class]="field_config_access['RES_preferredLocationIds'] &&field_config_access['RES_preferredLocationIds'].fieldClass ? field_config_access['RES_preferredLocationIds'].fieldClass :'col-md-12'"
                [ngStyle]="{'order': field_config_access['RES_preferredLocationIds'] &&field_config_access['RES_preferredLocationIds'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_preferredLocationIds'] ">
                <tm-multi-select [options]="timeBasedMaster.locationList||[]" [form_group]="resumeBankForm"
                  (selected_obj)="presentMultiLocationChanged($event)" form_control="preferredLocationIds"
                  title_property="title" id_property="id" float_label="always" [suffix_btn_icon]="' fa-ellipsis-h'"
                  [label]="field_config_access['RES_preferredLocationIds'].label ||'RESUME.Preferred locations for job search' | translate"
                  [label_action_title]="'Your city not found?'" [label_action_type]='1' [addFunc]="manageLocationsRef"
                  [data]="resumeBankForm.value.preferredLocationIds" [design_pattern]="4"
                  [placeholder]="field_config_access['RES_preferredLocationIds'].placeholder ||'<- - Select - ->' | translate">
                </tm-multi-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-right">
                <button style="min-width: 100px;" class="ml-auto  btn-sm blob-btn-cancel btn mx-1 mx-1 tallite-action"
                  matStepperPrevious (click)="previousStep(stepper)">
                  {{ 'BTN.previous' | translate}}
                  <span class="blob-btn-cancel__inner">
                    <span class="blob-btn-cancel__blobs">
                      <span class="blob-btn-cancel__blob"></span>
                      <span class="blob-btn-cancel__blob"></span>
                      <span class="blob-btn-cancel__blob"></span>
                      <span class="blob-btn-cancel__blob"></span>
                    </span>
                  </span>
                </button>
                <button style="min-width: 100px;" class="blob-btn btn-sm  btn   mx-1 tallite-action"
                  (click)="nextStep(2)" type="submit">
                  {{ 'BTN.next' | translate }}
                  <span class="blob-btn__inner">
                    <span class="blob-btn__blobs">
                      <span class="blob-btn__blob"></span>
                      <span class="blob-btn__blob"></span>
                      <span class="blob-btn__blob"></span>
                      <span class="blob-btn__blob"></span>
                    </span>
                  </span>
                </button>
              </div>
            </div>

          </form>
        </ng-template>

      </mat-step>
      <mat-step label="Employment" [editable]="resumeBankForm.value.resId">
        <!-- <mat-step label="Employment"> -->


        <ng-template matStepLabel>{{"EXTRA.Employment related"|translate}}</ng-template>
        <ng-template matStepContent>
          <form [formGroup]="resumeBankForm">
            <div class="row">

              <div
                [class]="this.field_config_access && this.field_config_access['RES_nationalityCode'] ?'col-md-9':'col-md-12'"
                *ngIf="this.field_config_access && this.field_config_access['RES_industryCodes']">
                <tm-multi-select [options]="masters.industryList||[]" [form_group]="resumeBankForm"
                  form_control="industryCodes" (selected_obj)="industryChanged($event)"
                  [label]=" this.field_config_access['RES_industryCodes'].label ||'RESUME.industry' | translate"
                  title_property="title" id_property="industryCode" float_label="always"
                  [data]="resumeBankForm.value.industryCodes" [mandatory]="field_config_access['RES_industryCodes'].validationScriptUI &&
            field_config_access['RES_industryCodes'].validationScriptUI.mandatory?1:0"
                  [placeholder]="this.field_config_access['RES_industryCodes'].placeholder ||'<- -Select- ->' | translate"
                  [label_overflow]="1">
                </tm-multi-select>
                <!-- <tm-multi-select [options]="industryList || []" [form_group]="resumeBankForm"
            form_control="industryCodes" title_property="title" id_property="industryCode"
            (selected_obj)="industryChanged($event)" float_label="always"
            [mandatory]="field_config_access && field_config_access['industry'] && field_config_access['industry'].mandatory && field_config_access['industry'].mandatory !='0'?1:0"
            [label]="'RESUME.industry' | translate" [data]="resumeBankForm.value.industry"
            [placeholder]="'< - - Select - - >' | translate">
          </tm-multi-select> -->
              </div>

              <div
                [class]="field_config_access['nationalityCode'] &&field_config_access['nationalityCode'].fieldClass ? field_config_access['nationalityCode'].fieldClass :'col-md-2'"
                [ngStyle]="{'order': field_config_access['nationalityCode'] &&field_config_access['nationalityCode'].fieldSeq}"
                *ngIf="this.field_config_access && this.field_config_access['RES_nationalityCode']">
                <tm-select [options]="masters.nationalityList||[]" [form_group]="resumeBankForm"
                  form_control="nationalityCode"
                  [label]=" this.field_config_access['RES_nationalityCode'].label|| 'RESUME.nationalityCode' |translate"
                  title_property="title" id_property="code" float_label="always"
                  [data]="resumeBankForm.value.nationalityCode" [placeholder]="'<- -Select- ->' | translate"
                  [label_overflow]="1">
                </tm-select>
              </div>
              <div
                [class]="field_config_access['RES_presentEmployer'] &&field_config_access['RES_presentEmployer'].fieldClass ? field_config_access['RES_presentEmployer'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_presentEmployer'] &&field_config_access['RES_presentEmployer'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_presentEmployer'] ">
                <mat-form-field floatLabel="always">
                  <mat-label> {{field_config_access['RES_presentEmployer'].label || 'RESUME.presentEmployer' | translate
                    }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="presentEmployer"
                    [placeholder]="field_config_access['RES_presentEmployer'].placeholder || 'RESUME.enterPresentEmployer' | translate "
                    [maxLength]="250">
                </mat-form-field>
              </div>
              <div
                [class]="field_config_access['RES_jobTitleId'] &&field_config_access['RES_jobTitleId'].fieldClass ? field_config_access['RES_jobTitleId'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_jobTitleId'] &&field_config_access['RES_jobTitleId'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_jobTitleId'] ">
                <tm-select [auto_addition]="1" [auto_form_control]="'designation'"
                  [master_obj]="jobseeker.jobTitleMasters" [enable_virtual_scroll]="1"
                  [auto_data]="resumeBankForm.value.designation" [options]="jobseeker.jobTitleList"
                  (fetchEntries)="loadJobtitleList($event)" [form_group]="resumeBankForm" form_control="jobTitleId"
                  title_property="title" id_property="id" float_label="always" [design_pattern]="4"
                  [label_action_title]="' not found? click here to add'" [label_action_type]="3"
                  [label]="this.field_config_access['RES_jobTitleId'].label ||'Designation' | translate"
                  [data]="resumeBankForm.value.jobTitleId" [mandatory]="field_config_access['RES_jobTitleId'].validationScriptUI &&
            field_config_access['RES_jobTitleId'].validationScriptUI.mandatory?1:0"
                  [placeholder]="this.field_config_access['RES_jobTitleId'].placeholder ||'RESUME.enterDesignation' | translate">
                </tm-select>

              </div>
              <div
                [class]="field_config_access['RES_noticePeriod'] &&field_config_access['RES_noticePeriod'].fieldClass ? field_config_access['RES_noticePeriod'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_noticePeriod'] &&field_config_access['RES_noticePeriod'].fieldSeq}"
                *ngIf=" field_config_access &&field_config_access['RES_noticePeriod']&& field_config_access['RES_noticePeriod'].validationScriptUI &&
          field_config_access['RES_noticePeriod'].validationScriptUI.convertToDropdown;else noticePeriodDropdown ">
                <tm-select [options]="masters.noticePeriodList||[]" [form_group]="resumeBankForm"
                  [auto_data]="jobseeker.current_notice_period && jobseeker.current_notice_period.allowEdit?resumeBankForm.value.noticePeriod :null"
                  [auto_form_control]="jobseeker.current_notice_period && jobseeker.current_notice_period.allowEdit ? 'noticePeriod':null"
                  [auto_addition]=" jobseeker.current_notice_period && jobseeker.current_notice_period.allowEdit "
                  form_control="noticePeriodId" title_property="title" (selected_obj)="currencyChanged($event,3)"
                  [mandatory]="field_config_access['RES_noticePeriod'].validationScriptUI &&
            field_config_access['RES_noticePeriod'].validationScriptUI.mandatory?1:0"
                  [label]=" field_config_access['RES_noticePeriod'].label ||'RESUME.noticePeriod' | translate"
                  id_property="id" float_label="always" [data]="resumeBankForm.value.noticePeriodId"
                  [placeholder]=" field_config_access['RES_noticePeriod'].placeholder ||'<- -Select- ->' | translate">
                </tm-select>
              </div>

              <ng-template #noticePeriodDropdown>
                <div class="col-md-2"
                  [class]="field_config_access['RES_noticePeriod'] &&field_config_access['RES_noticePeriod'].fieldClass ? field_config_access['RES_noticePeriod'].fieldClass :'col-md-4'"
                  [ngStyle]="{'order': field_config_access['RES_noticePeriod'] &&field_config_access['RES_noticePeriod'].fieldSeq}"
                  *ngIf=" field_config_access &&field_config_access['RES_noticePeriod']">
                  <mat-form-field floatLabel="always" class="notice-period">
                    <mat-label style="text-align: right !important;">
                      {{ field_config_access['RES_noticePeriod'].label|| 'RESUME.noticePeriod' | translate
                      }}
                    </mat-label>
                    <input type="number" class="w-93" matInput formControlName="noticePeriod"
                      [placeholder]="field_config_access['RES_noticePeriod'].placeholder||  'RESUME.enterNoticePeriod' | translate "
                      [max]="365" [min]="0">
                    <label class="attch2" matSuffix>Days</label>
                    <mat-error *ngIf="resumeBankForm.get('noticePeriod').hasError('min');else max ">
                      {{ 'ERROR.min_value' |translate }} 0
                    </mat-error>
                    <ng-template #max>
                      <mat-error *ngIf="resumeBankForm.get('noticePeriod').hasError('max');else pattern1">
                        {{"ERROR.max_value" |translate}} 365
                      </mat-error>
                    </ng-template>
                    <ng-template #pattern1>
                      <mat-error *ngIf="resumeBankForm.get('noticePeriod').hasError('pattern')">
                        {{"ERROR.invalid_input" |translate}}
                      </mat-error>
                    </ng-template>

                  </mat-form-field>

                </div>

              </ng-template>


              <!-- <div   [class]="field_config_access['RES_employmentHistory'] &&field_config_access['RES_employmentHistory'].fieldClass ? field_config_access['RES_employmentHistory'].fieldClass :'col-md-2'"

            [ngStyle]="{'order': field_config_access['RES_employmentHistory'] &&field_config_access['RES_employmentHistory'].fieldSeq}"
              *ngIf=" field_config_access &&!field_config_access['RES_servingNP']   && field_config_access['RES_employmentHistory']">
              <span class="link mat-mt" (click)="openWorkExperince()" style="font-size: 13px;"> Work
                Experience
                <ng-container
                  *ngIf="resumeBankForm.value.employmentHistory &&resumeBankForm.value.employmentHistory.length ">
                  ({{resumeBankForm.value.employmentHistory.length}})
                </ng-container>
              </span>
            </div> -->
              <div class="col-md-4" *ngIf="field_config_access && field_config_access['RES_servingNP']">
                <mat-checkbox formControlName="servingNP" (change)="checkboxEvent($event,'servingNP')">
                  {{ field_config_access['RES_servingNP'].label || "RESUME.servingNP"|translate}}
                </mat-checkbox>
              </div>
              <div
                [class]="field_config_access['RES_lwd'] &&field_config_access['RES_lwd'].fieldClass ? field_config_access['RES_lwd'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_lwd'] &&field_config_access['RES_lwd'].fieldSeq}"
                *ngIf="resumeBankForm.value.servingNP &&  field_config_access &&field_config_access['RES_lwd']">
                <tm-date-picker [form]="resumeBankForm" [controlName]="'lwd'"
                  [placeholder]=" 'Select date' | translate "
                  [label]="field_config_access['RES_lwd'].placeholder ||'Last working date' |translate"
                  [value]="resumeBankForm.value.lwd">
                </tm-date-picker>
              </div>
              <!-- <div [class]="field_config_access['RES_noticePeriod'] &&field_config_access['RES_noticePeriod'].fieldClass ? field_config_access['RES_noticePeriod'].fieldClass :'col-md-2'"

              [ngStyle]="{'order': field_config_access['RES_noticePeriod'] &&field_config_access['RES_noticePeriod'].fieldSeq}"
               *ngIf="field_config_access && field_config_access['RES_noticePeriod'] ">
                <mat-form-field floatLabel="always" class="notice-period">
                  <mat-label style="text-align: right !important;">
                    {{ field_config_access['RES_noticePeriod'].label ||'RESUME.noticePeriod' | translate }}</mat-label>
                  <input type="number" class="w-93" matInput formControlName="noticePeriod"
                    [placeholder]="field_config_access['RES_noticePeriod'].placeholder || 'RESUME.enterNoticePeriod' | translate"
                    [max]="365" [min]="0">
                  <label class="attch2" matSuffix>Days</label>
                  <mat-error *ngIf="resumeBankForm.get('noticePeriod').hasError('min');else max ">
                    {{ 'ERROR.min_value' |translate }} 0
                  </mat-error>
                  <ng-template #max>
                    <mat-error *ngIf="resumeBankForm.get('noticePeriod').hasError('max');else pattern1">
                      {{"ERROR.max_value" |translate}} 365
                    </mat-error>
                  </ng-template>
                  <ng-template #pattern1>
                    <mat-error *ngIf="resumeBankForm.get('noticePeriod').hasError('pattern')">
                      {{"ERROR.invalid_input" |translate}}
                    </mat-error>
                  </ng-template>

                </mat-form-field>
              </div> -->
              <div
                [class]="field_config_access['RES_totalExp'] &&field_config_access['RES_totalExp'].fieldClass ? field_config_access['RES_totalExp'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_totalExp'] &&field_config_access['RES_totalExp'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_totalExp'] ">
                <mat-form-field floatLabel="always" class="label-overflow">
                  <mat-label>{{ field_config_access['RES_totalExp'].label ||'RESUME.totalExperience'|translate}}
                  </mat-label>
                  <input type="number" matInput
                    [placeholder]="field_config_access['RES_totalExp'].placeholder ||'RESUME.enterExperience' | translate"
                    formControlName="totalExp" name="totalExp" [max]="100" [min]="0" />
                  <label class="attch2" matSuffix>Years</label>
                  <mat-error *ngIf="resumeBankForm.get('totalExp').hasError('min');else max_exp ">
                    {{ 'ERROR.min_value' |translate }} 0
                  </mat-error>
                  <ng-template #max_exp>
                    <mat-error *ngIf="resumeBankForm.get('totalExp').hasError('max');else max_pattern">
                      {{"ERROR.max_value" |translate}} 99
                    </mat-error>
                  </ng-template>
                  <ng-template #max_pattern>
                    <mat-error *ngIf="resumeBankForm.get('totalExp').hasError('pattern')">
                      {{"ERROR.invalid_input" |translate}}
                    </mat-error>
                  </ng-template>
                </mat-form-field>
              </div>
              <div
                [class]="field_config_access['RES_presentSalary'] &&field_config_access['RES_presentSalary'].fieldClass ? field_config_access['RES_presentSalary'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_presentSalary'] &&
                field_config_access['RES_presentSalary'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_presentSalary'] ">
                <div class="prefix-control" style="width: 30%;">
                  <tm-select [options]="masters.currencyList||[]" [form_group]="resumeBankForm"
                    form_control="presentSalaryCurrId"
                    [label]=" field_config_access['RES_presentSalary'].label ||'RESUME.presentSalary' |translate"
                    title_property="currencySymbol" id_property="currencyId" float_label="always"
                    [data]="resumeBankForm.value.presentSalaryCurrId"
                    [placeholder]="'RESUME.currencyPlaceholder' | translate" [label_overflow]="1">
                  </tm-select>
                </div>
                <div class="main-control" style="width: 40%;">
                  <mat-form-field floatLabel="always" class="no-label">
                    <mat-label>{{'Present Salary' | translate}}
                    </mat-label>
                    <input type="number" class="w-93" matInput formControlName="presentSalary"
                      [placeholder]="field_config_access['RES_presentSalary'].placeholder || 'RESUME.enterPresentSalary' | translate ">
                    <mat-error *ngIf="resumeBankForm.get('presentSalary').hasError('pattern')">
                      {{'ERROR.invalid_input' |translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="suffix-control" style="width: 30%;">
                  <tm-select [options]="masters.scaleDurationList||[]" [form_group]="resumeBankForm"
                    form_control="presentSalaryScaleDurationId" title_property="name" [label]="'Scale' | translate"
                    id_property="scaleDurationId" float_label="always" [width]="152"
                    [data]="resumeBankForm.value.presentSalaryScaleDurationId"
                    [placeholder]="'RESUME.scalePlaceholder' | translate" [hide_label]="1">
                  </tm-select>
                </div>
              </div>
              <div
                [class]="field_config_access['RES_expSalary'] &&
              field_config_access['RES_expSalary'].fieldClass ? field_config_access['RES_expSalary'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_expSalary'] &&
              field_config_access['RES_expSalary'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_expSalary'] ">
                <div class="prefix-control" style="width: 30%;">
                  <tm-select [options]="masters.currencyList||[]" [form_group]="resumeBankForm"
                    form_control="expSalaryCurrId" title_property="currencySymbol" id_property="currencyId"
                    float_label="always"
                    [label]=" field_config_access['RES_expSalary'].label ||'RESUME.expectedSalary' |translate"
                    [data]="resumeBankForm.value.expSalaryCurrId"
                    [placeholder]=" field_config_access['RES_expSalary'].placeholder ||'RESUME.currencyPlaceholder' | translate"
                    [label_overflow]="1">
                  </tm-select>
                </div>
                <div class="main-control" style="width: 40%;">
                  <mat-form-field floatLabel="always" class="no-label">
                    <mat-label>
                    </mat-label>
                    <input type="number" class="w-93" matInput formControlName="expSalary"
                      [placeholder]=" field_config_access['RES_expSalary'].placeholder || 'RESUME.enterExpectedSalary' | translate ">
                    <mat-error *ngIf="resumeBankForm.get('expSalary').hasError('pattern')">
                      {{'ERROR.invalid_input' |translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="suffix-control" style="width: 30%;">
                  <tm-select [options]="masters.scaleDurationList||[]" [form_group]="resumeBankForm"
                    form_control="expSalaryScaleDurationId" title_property="name" id_property="scaleDurationId"
                    float_label="always" [width]="170" [data]="resumeBankForm.value.expSalaryScaleDurationId"
                    [hide_label]="1" [placeholder]="'RESUME.scalePlaceholder' | translate"
                    [label]="'Scale' | translate">
                  </tm-select>
                </div>
              </div>
              <!-- <div  [class]="field_config_access['RES_enableBankDetails'] &&field_config_access['RES_enableBankDetails'].fieldClass ? field_config_access['RES_enableBankDetails'].fieldClass :'col-md-2'"

              [ngStyle]="{'order': field_config_access['RES_enableBankDetails'] &&field_config_access['RES_enableBankDetails'].fieldSeq}"
              *ngIf=" field_config_access &&field_config_access['RES_enableBankDetails'] && field_config_access['RES_enableBankDetails']">
              <span class="link mat-mt" (click)="openBankDetails()" style="font-size: 13px;">
                {{field_config_access['RES_enableBankDetails'].label|| "Bank Details"}}
                <ng-container
                  *ngIf="resumeBankForm.value.employmentHistory &&resumeBankForm.value.employmentHistory.length ">
                  ({{resumeBankForm.value.employmentHistory.length}})
                </ng-container>
              </span>
            </div> -->
              <div class="col-md-6" *ngIf="false">
                <label class="d-block m-0" for="" style="font-size: 12px;
                                             color: black; font-weight: 500; opacity: .9;">{{'RESUME.resumeRating'
                  |translate}}
                  <!-- <span (click)="openGuideline()" class="cursor" style="font-size: 14px;color: red;">
                      <i style="font-weight: bold;" class="fa fa-question-circle ">
                        {{'RESUME.ratingGuideline' |translate}} </i>
                    </span> -->
                </label>
                <div style="position: relative;">
                  <mat-star-rating [form_group]="resumeBankForm" [form_control]="'cvRating'"
                    [rating]="this.resumeBankForm.value.cvRating ||1" [starCount]="starCount" [color]="starColor"
                    (ratingUpdated)="onCandidateRatingChanged($event)">
                  </mat-star-rating>
                  <span class="ml-2" style="font-size: 14px;position:absolute;top:11px;">
                    {{cv_rating_title}}

                  </span>


                </div>
              </div>
              <!-- <div class="col-md-4">
                  <span (click)="openGuideline()" class="cursor"
                    style="font-size: 14px;position:absolute;top:28px;color: red;">
                    <i style="font-weight: bold;" class="fa fa-question-circle ">
                      {{'RESUME.ratingGuideline' |translate}} </i>
                  </span>
                </div> -->
              <div class="col-md-6" *ngIf="false">
                <label class="d-block m-0" for=""
                  style="font-size: 12px;
                                              color: black; font-weight: 500; opacity: .9;">{{'RESUME.ratingCommunicationSkills' |translate}}
                  <!-- <span (click)="openGuidelineCommunication()" class="cursor" style="font-size: 14px;color: red;">
                      <i style="font-weight: bold;" class="fa fa-question-circle ">
                        {{'RESUME.ratingGuideline' |translate}} </i>
                    </span> -->
                </label>
                <div style="position: relative;">
                  <mat-star-rating [form_group]="resumeBankForm" [form_control]="'commSkillRating'"
                    [rating]="this.resumeBankForm.value.commSkillRating ||1" [starCount]="starCount" [color]="starColor"
                    (ratingUpdated)="commRating($event)">
                  </mat-star-rating>
                  <span class="ml-2" style="font-size: 14px;position:absolute;top:11px;">
                    {{comm_rating_title}}
                  </span>
                </div>
              </div>
              <div [class]="field_config_access['RES_dob'] &&
              field_config_access['RES_dob'].fieldClass ? field_config_access['RES_dob'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_dob'] &&
              field_config_access['RES_dob'].fieldSeq}" *ngIf="field_config_access && field_config_access['RES_dob'] ">
                <tm-date-picker [start_view]="'multi-year'" [form]="resumeBankForm" [controlName]="'dob'"
                  [value]="resumeBankForm.value.dob" [maxValue]="startAt" [startAt]="startAt" [minValue]="minValue"
                  [required]=" field_config_access['RES_dob'] && field_config_access['RES_dob'].validationScriptUI  && field_config_access['RES_dob'].validationScriptUI.mandatory"
                  [label]=" field_config_access['RES_dob'].label ||'Birth Date (Affirmative action to support EEO)'|translate">
                </tm-date-picker>
              </div>
              <div
                [class]="field_config_access['RES_genderCode'] &&
              field_config_access['RES_genderCode'].fieldClass ? field_config_access['RES_genderCode'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_genderCode'] &&
              field_config_access['RES_genderCode'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_genderCode'] ">
                <!-- <mat-form-field floatLabel="always" class="tm-radio-group">
                  <mat-label>
                    {{ field_config_access['RES_genderCode'].label ||'Gender(Affirmative action to support EEO)' |
                    translate }}
                     <span
                                                            *ngIf="this.validation_lang_data[3].isMandatory">*</span> -->
                <!-- </mat-label> -->
                <!-- <input formControlName="genderCode" matInput class="d-none"> -->
                <!-- <mat-radio-group formControlName="genderCode">
                    <mat-radio-button *ngFor="let item of masters.genderList" [value]="item.genderCode"> {{item.title}}
                    </mat-radio-button> -->
                <!-- <mat-radio-button [value]="2">Male</mat-radio-button>
                    <mat-radio-button [value]="3">Female</mat-radio-button>
                    <mat-radio-button [value]="4">Transgender</mat-radio-button> -->
                <!-- </mat-radio-group> -->
                <!-- </mat-form-field>  -->
                <tm-select [options]="masters.genderList||[]" [form_group]="resumeBankForm" form_control="genderCode"
                  [label]=" this.field_config_access['RES_genderCode'].label|| 'Gender(Affirmative action to support EEO)' |translate"
                  title_property="title" id_property="code" float_label="always"
                  [data]="resumeBankForm.value.genderCode" [placeholder]="'<- -Select- ->' | translate"
                  [label_overflow]="1">
                </tm-select>

              </div>
              <ng-container *ngIf="this.field_config_access && this.field_config_access['RES_ppNumber']">
                <div
                  [class]="field_config_access['RES_ppNumber'] &&
                field_config_access['RES_ppNumber'].fieldClass ? field_config_access['RES_ppNumber'].fieldClass :'col-md-4'"
                  [ngStyle]="{'order': field_config_access['RES_ppNumber'] &&
                field_config_access['RES_ppNumber'].fieldSeq}"
                  *ngIf="this.field_config_access && this.field_config_access['RES_ppNumber']">
                  <mat-form-field floatLabel="always">
                    <mat-label>
                      {{ this.field_config_access['RES_ppNumber'].label || "RESUME.ppNumber"|translate}}
                    </mat-label>
                    <input matInput
                      [placeholder]="this.field_config_access['RES_ppNumber'].placeholder ||'RESUME.enter_ppNumber'|translate"
                      formControlName="ppNumber">
                    <mat-error *ngIf="resumeBankForm.get('ppNumber').hasError('pattern') ;else ppReq">
                      {{'ERROR.invalid_input' | translate}}
                    </mat-error>
                    <ng-template #ppReq>
                      <mat-error>
                        {{'ERROR.field_is_mandatory' | translate}}
                      </mat-error>
                    </ng-template>
                  </mat-form-field>
                </div>
                <div
                  [class]="field_config_access['RES_ppIssueDate'] &&
                field_config_access['RES_ppNumber'].fieldClass ? field_config_access['RES_ppIssueDate'].fieldClass :'col-md-4'"
                  [ngStyle]="{'order': field_config_access['RES_ppIssueDate'] &&
                field_config_access['RES_ppIssueDate'].fieldSeq}"
                  *ngIf="this.field_config_access && this.field_config_access['RES_ppIssueDate']">
                  <tm-date-picker [form]="resumeBankForm" [controlName]="'ppIssueDate'"
                    (onChange)="issueDateChanged($event)" [placeholder]=" 'Passport issue date' | translate"
                    [label]=" 'Passport issue date' | translate " [value]="resumeBankForm.value.ppIssueDate">
                  </tm-date-picker>
                </div>
                <div
                  [class]="field_config_access['RES_ppExpiryDate'] &&
                field_config_access['RES_ppExpiryDate'].fieldClass ? field_config_access['RES_ppExpiryDate'].fieldClass :'col-md-4'"
                  [ngStyle]="{'order': field_config_access['RES_ppExpiryDate'] &&
                field_config_access['RES_ppExpiryDate'].fieldSeq}"
                  *ngIf="this.field_config_access && this.field_config_access['RES_ppExpiryDate']&& this.field_config_access['RES_ppNumber']">
                  <tm-date-picker [form]="resumeBankForm" [controlName]="'ppExpiryDate'"
                    [placeholder]=" this.field_config_access['RES_ppExpiryDate'].placeholder|| 'RESUME.ppExpiryDate' | translate"
                    [label]=" this.field_config_access['RES_ppExpiryDate'].label || 'RESUME.ppExpiryDate' | translate "
                    [value]="resumeBankForm.value.ppExpiryDate" [minValue]="resumeBankForm.value.ppIssueDate">
                  </tm-date-picker>
                </div>
                <div [class]="field_config_access['RES_isECR'] &&
                field_config_access['RES_isECR'].fieldClass ? field_config_access['RES_isECR'].fieldClass :'col-md-4'"
                  [ngStyle]="{'order': field_config_access['RES_isECR'] &&
                field_config_access['RES_isECR'].fieldSeq}"
                  *ngIf="this.field_config_access && this.field_config_access['RES_isECR']">
                  <mat-button-toggle-group formControlName="isECR" class="mb-2">
                    <mat-button-toggle [value]="1"> {{'ECR' |translate}} </mat-button-toggle>
                    <mat-button-toggle [value]="0"> {{'ECNR' |translate}} </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </ng-container>



              <div
                [class]="field_config_access['RES_functionalArea'] &&
              field_config_access['RES_functionalArea'].fieldClass ? field_config_access['RES_functionalArea'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_functionalArea'] &&
              field_config_access['RES_functionalArea'].fieldSeq}"
                *ngIf="this.field_config_access && this.field_config_access['RES_functionalArea']">
                <tm-multi-select [options]="masters.functionalAreaList || []" [form_group]="resumeBankForm"
                  [mandatory]="field_config_access['RES_functionalArea'].validationScriptUI && field_config_access['RES_functionalArea'].validationScriptUI.mandatory?true:false"
                  form_control="functionalArea" title_property="title" id_property="id" float_label="always"
                  [label]="this.field_config_access['RES_functionalArea'].label ||'Functional area' | translate"
                  [data]="resumeBankForm.value.functionalArea"
                  [placeholder]=" this.field_config_access['RES_functionalArea'].placeholder|| '< - - Select - - >' | translate">
                </tm-multi-select>
              </div>

              <div
                [class]="field_config_access['RES_netSalary'] &&
              field_config_access['RES_netSalary'].fieldClass ? field_config_access['RES_netSalary'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_netSalary'] &&
              field_config_access['RES_netSalary'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_netSalary']">
                <div class="prefix-control" style="width: 20%;">
                  <tm-select [options]="masters.currencyList||[]" [form_group]="resumeBankForm"
                    form_control="netSalaryCurrId"
                    [label]="field_config_access['RES_netSalary'].label|| 'Net salary'|translate"
                    title_property="currencySymbol" id_property="currencyId" float_label="always"
                    [data]="resumeBankForm.value.netSalaryCurrId"
                    [placeholder]="'RESUME.currencyPlaceholder' | translate" [label_overflow]="1">
                  </tm-select>
                </div>
                <div class="main-control" style="width: 30%;">
                  <mat-form-field floatLabel="always" class="no-label">
                    <mat-label></mat-label>
                    <input type="number" formControlName="netSalary" matInput
                      [placeholder]="field_config_access['RES_netSalary'].placeholder|| 'Enter Net salary' | translate">
                  </mat-form-field>

                  <!-- <tm-select [options]="master_data.currencyScaleMapList||[]" [form_group]="resumeBankForm"
                    [input_class]="'text-right'"
                    [auto_data]="jobseeker.current_net_salary && jobseeker.current_net_salary.allowEdit?resumeBankForm.value.netSalary :null"
                    [auto_form_control]="jobseeker.current_net_salary && jobseeker.current_net_salary.allowEdit ? 'netSalary':null"
                    [auto_addition]="jobseeker.current_net_salary && jobseeker.current_net_salary.allowEdit "
                    form_control="netSalaryValueMapId" title_property="title"
                    (selected_obj)="currencyChanged($event,5)" [label]="'Scale' | translate"
                    id_property="value" float_label="always"
                    [data]="resumeBankForm.value.netSalaryValueMapId "
                    [placeholder]="field_config_access['RES_netSalary'].placeholder|| '<- -Select- ->' | translate"
                    [hide_label]="1">
                  </tm-select> -->
                </div>
                <div class="suffix-control" style="width: 45%;">
                  <tm-select [options]="masters.scaleDurationList||[]" [form_group]="resumeBankForm"
                    form_control="netSalarySDTemplateCode" title_property="name" [label]="'Scale' | translate"
                    id_property="scaleDurationId" float_label="always" [width]="152"
                    [data]="resumeBankForm.value.netSalarySDTemplateCode "
                    [placeholder]="'RESUME.scalePlaceholder' | translate" [hide_label]="1">
                  </tm-select>
                </div>
              </div>
              <div
                [class]="field_config_access['RES_vaccinationStatus'] &&
              field_config_access['RES_vaccinationStatus'].fieldClass ? field_config_access['RES_vaccinationStatus'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_vaccinationStatus'] &&
              field_config_access['RES_vaccinationStatus'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_vaccinationStatus']">
                <mat-form-field floatLabel="always" class="tm-radio-group">
                  <mat-label>
                    {{ field_config_access['RES_vaccinationStatus'].label|| 'Vaccination status' |
                    translate}}
                  </mat-label>
                  <input formControlName="vaccinationStatus" class="d-none" matInput>

                  <mat-radio-group formControlName="vaccinationStatus" aria-label="Select an option">
                    <mat-radio-button [value]="1">Yes</mat-radio-button>
                    <mat-radio-button [value]="0">No</mat-radio-button>
                  </mat-radio-group>
                </mat-form-field>

              </div>
              <div
                [class]="field_config_access['RES_vaccinationDate'] &&
            field_config_access['RES_vaccinationDate'].fieldClass ? field_config_access['RES_vaccinationDate'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_vaccinationDate'] &&
            field_config_access['RES_vaccinationDate'].fieldSeq}"
                *ngIf="resumeBankForm.value.vaccinationStatus==1 && field_config_access && field_config_access['RES_vaccinationDate']">
                <tm-date-picker [form]="resumeBankForm" [controlName]="'vaccinationDate'"
                  [placeholder]="field_config_access['RES_vaccinationDate'].placeholder||'Vaccination Date' | translate"
                  [label]="field_config_access['RES_vaccinationDate'].label||'Vaccination Date' | translate "
                  [value]="resumeBankForm.value.vaccinationDate">
                </tm-date-picker>
              </div>
              <div [class]="field_config_access['RES_PFNumber'] &&
          field_config_access['RES_PFNumber'].fieldClass ? field_config_access['RES_PFNumber'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_PFNumber'] &&
          field_config_access['RES_PFNumber'].fieldSeq}"
                *ngIf="this.field_config_access && this.field_config_access['RES_PFNumber']">
                <mat-form-field floatLabel="always">
                  <mat-label> {{this.field_config_access['RES_PFNumber'].label ||
                    'PF Number' | translate }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="PFNumber"
                    [placeholder]=" this.field_config_access['RES_PFNumber'].placeholder|| 'Enter PF number' | translate"
                    [maxLength]="250">
                </mat-form-field>
              </div>
              <div [class]="field_config_access['RES_UANNumber'] &&
        field_config_access['RES_UANNumber'].fieldClass ? field_config_access['RES_UANNumber'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_UANNumber'] &&
        field_config_access['RES_UANNumber'].fieldSeq}"
                *ngIf="this.field_config_access && this.field_config_access['RES_UANNumber']">
                <mat-form-field floatLabel="always">
                  <mat-label> {{this.field_config_access['RES_UANNumber'].label ||
                    'UAN Number' | translate }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="UANNumber"
                    [placeholder]=" this.field_config_access['RES_UANNumber'].placeholder|| 'Enter UAN number' | translate"
                    [maxLength]="250">
                </mat-form-field>
              </div>
              <div [class]="field_config_access['RES_ESINumber'] &&
        field_config_access['RES_ESINumber'].fieldClass ? field_config_access['RES_ESINumber'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_ESINumber'] &&
        field_config_access['RES_ESINumber'].fieldSeq}"
                *ngIf="this.field_config_access && this.field_config_access['RES_ESINumber']">
                <mat-form-field floatLabel="always">
                  <mat-label> {{this.field_config_access['RES_ESINumber'].label ||
                    'ESI Number' | translate }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="ESINumber"
                    [placeholder]=" this.field_config_access['RES_ESINumber'].placeholder|| 'Enter ESI number' | translate"
                    [maxLength]="250">
                </mat-form-field>
              </div>
              <div
                [class]="field_config_access['RES_martialStatus'] &&
        field_config_access['RES_martialStatus'].fieldClass ? field_config_access['RES_martialStatus'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_martialStatus'] &&
        field_config_access['RES_martialStatus'].fieldSeq}"
                *ngIf="this.field_config_access && this.field_config_access['RES_martialStatus']">
                <tm-select [options]="masters.maritalList" [form_group]="resumeBankForm" form_control="martialStatus"
                  [label]="this.field_config_access['RES_martialStatus'].label|| 'Marital status' |translate"
                  title_property="title" id_property="id" float_label="always"
                  [data]="resumeBankForm.value.martialStatus" [placeholder]="'<- -Select- ->' | translate"
                  [label_overflow]="1">
                </tm-select>
              </div>
              <div
                [class]="field_config_access['RES_marriageDate'] &&
      field_config_access['RES_marriageDate'].fieldClass ? field_config_access['RES_marriageDate'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_marriageDate'] &&
      field_config_access['RES_marriageDate'].fieldSeq}"
                *ngIf="resumeBankForm.value.martialStatus==2 && field_config_access && field_config_access['RES_marriageDate']">
                <tm-date-picker [form]="resumeBankForm" [controlName]="'marriageDate'"
                  [placeholder]="field_config_access['RES_marriageDate'].placeholder||'Marriage date' | translate"
                  [label]="field_config_access['RES_marriageDate'].label||'Marriage date' | translate "
                  [value]="resumeBankForm.value.marriageDate" [maxValue]="today">
                </tm-date-picker>
              </div>
              <div [class]="field_config_access['RES_spouseName'] &&
      field_config_access['RES_spouseName'].fieldClass ? field_config_access['RES_spouseName'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_spouseName'] &&
      field_config_access['RES_spouseName'].fieldSeq}"
                *ngIf="resumeBankForm.value.martialStatus==2 && this.field_config_access && this.field_config_access['RES_spouseName']">
                <mat-form-field floatLabel="always">
                  <mat-label> {{this.field_config_access['RES_spouseName'].label ||
                    'Spouse name' | translate }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="spouseName"
                    [placeholder]=" this.field_config_access['RES_spouseName'].placeholder|| 'Enter spouse name' | translate"
                    [maxLength]="250">
                </mat-form-field>
              </div>
              <div
                [class]="field_config_access['RES_personalEmailID'] &&
      field_config_access['RES_personalEmailID'].fieldClass ? field_config_access['RES_personalEmailID'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_personalEmailID'] &&
      field_config_access['RES_personalEmailID'].fieldSeq}"
                *ngIf="this.field_config_access && this.field_config_access['RES_personalEmailID']">
                <mat-form-field floatLabel="always">
                  <mat-label> {{this.field_config_access['RES_personalEmailID'].label ||
                    'Personal Email ID' | translate }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="personalEmailID"
                    [placeholder]=" this.field_config_access['RES_personalEmailID'].placeholder|| 'Enter email id' | translate"
                    [maxLength]="250">
                </mat-form-field>
              </div>
              <div [class]="field_config_access['RES_bloodGroup'] &&
      field_config_access['RES_bloodGroup'].fieldClass ? field_config_access['RES_bloodGroup'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_bloodGroup'] &&
      field_config_access['RES_bloodGroup'].fieldSeq}"
                *ngIf="this.field_config_access && this.field_config_access['RES_bloodGroup']">
                <tm-select [options]="masters.bloodGroupList||[]" [form_group]="resumeBankForm"
                  form_control="bloodGroup"
                  [label]="this.field_config_access['RES_bloodGroup'].label|| 'Blood group' |translate"
                  title_property="title" id_property="id" float_label="always"
                  [data]="resumeBankForm.value.martialStatus" [placeholder]="'<- -Select- ->' | translate"
                  [label_overflow]="1">
                </tm-select>
              </div>
              <div [class]="field_config_access['RES_fatherName'] &&
      field_config_access['RES_fatherName'].fieldClass ? field_config_access['RES_fatherName'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_fatherName'] &&
      field_config_access['RES_fatherName'].fieldSeq}"
                *ngIf="this.field_config_access && this.field_config_access['RES_fatherName']">
                <mat-form-field floatLabel="always">
                  <mat-label> {{this.field_config_access['RES_fatherName'].label ||
                    'Father name' | translate }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="fatherName"
                    [placeholder]=" this.field_config_access['RES_fatherName'].placeholder|| 'Enter father name' | translate"
                    [maxLength]="250">
                </mat-form-field>
              </div>
              <div
                [class]="field_config_access['RES_isSpeciallyAbled'] &&
      field_config_access['RES_isSpeciallyAbled'].fieldClass ? field_config_access['RES_isSpeciallyAbled'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_isSpeciallyAbled'] &&
      field_config_access['RES_isSpeciallyAbled'].fieldSeq}"
                *ngIf="field_config_access && field_config_access['RES_isSpeciallyAbled']">
                <mat-checkbox formControlName="isSpeciallyAbled" (change)="checkboxEvent($event,'isSpeciallyAbled')">
                  {{ field_config_access['RES_isSpeciallyAbled'].label || "Specially abled "|translate}}
                </mat-checkbox>
              </div>
              <div
                [class]="field_config_access['RES_ speciallyAbled'] &&
      field_config_access['RES_ speciallyAbled'].fieldClass ? field_config_access['RES_ speciallyAbled'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_ speciallyAbled'] &&
      field_config_access['RES_ speciallyAbled'].fieldSeq}"
                *ngIf="resumeBankForm.value.isSpeciallyAbled==1 && field_config_access && field_config_access['RES_ speciallyAbled']">
                <tm-multi-select #search_input [options]="masters.speciallyabledList||[]" [form_group]="resumeBankForm"
                  form_control="speciallyAbled" title_property="title" id_property="id" float_label="always"
                  [label]=" field_config_access['RES_ speciallyAbled'].label|| 'Specially abled' | translate"
                  [data]="resumeBankForm.value.speciallyAbled"
                  [placeholder]=" field_config_access['RES_ speciallyAbled'].placeholder || '< - - Select - - > '">
                </tm-multi-select>
              </div>
              <div
                [class]="field_config_access['RES_specialAbledDesc'] &&
      field_config_access['RES_specialAbledDesc'].fieldClass ? field_config_access['RES_specialAbledDesc'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_specialAbledDesc'] &&
      field_config_access['RES_specialAbledDesc'].fieldSeq}"
                *ngIf="resumeBankForm.value.isSpeciallyAbled==1 && this.field_config_access && this.field_config_access['RES_specialAbledDesc']">
                <mat-form-field floatLabel="always">
                  <mat-label> {{this.field_config_access['RES_specialAbledDesc'].label ||
                    'Specially abled description' | translate }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="specialAbledDesc"
                    [placeholder]=" this.field_config_access['RES_specialAbledDesc'].placeholder|| 'Enter description' | translate"
                    [maxLength]="250">
                </mat-form-field>
              </div>
              <!-- <div [class]="field_config_access['RES_drivingLicense'] &&
      field_config_access['RES_drivingLicense'].fieldClass ? field_config_access['RES_drivingLicense'].fieldClass :'col-md-2'"
      [ngStyle]="{'order': field_config_access['RES_drivingLicense'] &&
      field_config_access['RES_drivingLicense'].fieldSeq}"
      *ngIf=" field_config_access && field_config_access['RES_drivingLicense']">
      <span class="link mat-mt" (click)="openDrivingLicense()" style="font-size: 13px;">
        {{field_config_access['RES_drivingLicense'].label|| "Driving license"}}
        <ng-container
          *ngIf="resumeBankForm.value.drivingLicense && resumeBankForm.value.drivingLicense.length">
          ({{resumeBankForm.value.drivingLicense.length}})
        </ng-container>
      </span>
    </div> -->
              <div class="col-md-2"
                [class]="field_config_access['RES_panCardNumber'] &&
    field_config_access['RES_panCardNumber'].fieldClass ? field_config_access['RES_panCardNumber'].fieldClass :'col-md-4'" [ngStyle]="{'order': field_config_access['RES_panCardNumber'] &&
    field_config_access['RES_panCardNumber'].fieldSeq}"
                *ngIf="field_config_access &&field_config_access['RES_panCardNumber']">
                <!-- <tm-mask-text [form]="resumeBankForm" [controlName]="'panCardNumber'"
        [label]="field_config_access['RES_panCardNumber'].label"
        [placeholder]=" field_config_access['RES_panCardNumber'].placeholder ||  'Enter pan card number' | translate ">
      </tm-mask-text> -->
                <mat-form-field floatLabel="always">
                  <mat-label> {{ field_config_access['RES_panCardNumber'].label ||'Pan card number' |
                    translate }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="panCardNumber"
                    [placeholder]="  field_config_access['RES_panCardNumber'].placeholder ||  'Enter pan card number' | translate ">
                  <mat-error *ngIf="resumeBankForm.get('panCardNumber').hasError('pattern')">
                    {{'ERROR.invalid_input' |translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div [class]="field_config_access['RES_panAttach'] &&
    field_config_access['RES_panAttach'].fieldClass ? field_config_access['RES_panAttach'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_panAttach'] &&
    field_config_access['RES_panAttach'].fieldSeq}" *ngIf="field_config_access &&field_config_access['RES_panAttach']">
                <tm-files-v2 [form_group]="resumeBankForm" [form_control]="'panAttach'"
                  [result]="resumeBankForm.value.panAttach"
                  [label]=" field_config_access['RES_panAttach'].label || 'Attach aadhar document' ">
                </tm-files-v2>
              </div>


              <div
                [class]="field_config_access['RES_aadharNumber'] &&
    field_config_access['RES_aadharNumber'].fieldClass ? field_config_access['RES_aadharNumber'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_aadharNumber'] &&
    field_config_access['RES_aadharNumber'].fieldSeq}"
                *ngIf="field_config_access &&field_config_access['RES_aadharNumber']">
                <mat-form-field floatLabel="always">
                  <mat-label> {{ 'Aadhar card number' | translate }}
                  </mat-label>
                  <input type="text" class="w-93" matInput formControlName="aadharNumber" maxlength="12"
                    [placeholder]="  field_config_access['RES_aadharNumber'].placeholder ||  'Enter aadhar card number' | translate ">
                  <mat-error *ngIf="resumeBankForm.get('aadharNumber').hasError('pattern')">
                    {{'ERROR.invalid_input' |translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div
                [class]="field_config_access['RES_aadharAttach'] &&
    field_config_access['RES_aadharAttach'].fieldClass ? field_config_access['RES_aadharAttach'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_aadharAttach'] &&
    field_config_access['RES_aadharAttach'].fieldSeq}"
                *ngIf="field_config_access &&field_config_access['RES_aadharAttach']">
                <tm-files-v2 [form_group]="resumeBankForm" [form_control]="'aadharAttach'"
                  [result]="resumeBankForm.value.aadharAttach"
                  [label]=" field_config_access['RES_aadharAttach'].label || 'Attach aadhar document' ">
                </tm-files-v2>
              </div>
              <div
                [class]="field_config_access['RES_employmentHistory'] &&field_config_access['RES_employmentHistory'].fieldClass ? field_config_access['RES_employmentHistory'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_employmentHistory'] &&field_config_access['RES_employmentHistory'].fieldSeq}"
                *ngIf=" field_config_access &&!field_config_access['RES_servingNP']   && field_config_access['RES_employmentHistory']">
                <span class="link mat-mt" (click)="openWorkExperince()" style="font-size: 13px;"> Work
                  Experience
                  <ng-container
                    *ngIf="resumeBankForm.value.employmentHistory &&resumeBankForm.value.employmentHistory.length ">
                    ({{resumeBankForm.value.employmentHistory.length}})
                  </ng-container>
                </span>
              </div>
              <div
                [class]="field_config_access['RES_enableBankDetails'] &&field_config_access['RES_enableBankDetails'].fieldClass ? field_config_access['RES_enableBankDetails'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_enableBankDetails'] &&field_config_access['RES_enableBankDetails'].fieldSeq}"
                *ngIf=" field_config_access &&field_config_access['RES_enableBankDetails'] && field_config_access['RES_enableBankDetails']">
                <span class="link mat-mt" (click)="openBankDetails()" style="font-size: 13px;">
                  {{field_config_access['RES_enableBankDetails'].label|| "Bank Details"}}
                  <ng-container
                    *ngIf="resumeBankForm.value.employmentHistory &&resumeBankForm.value.employmentHistory.length ">
                    ({{resumeBankForm.value.employmentHistory.length}})
                  </ng-container>
                </span>
              </div>
              <div
                [class]="field_config_access['RES_drivingLicense'] &&
  field_config_access['RES_drivingLicense'].fieldClass ? field_config_access['RES_drivingLicense'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_drivingLicense'] &&
  field_config_access['RES_drivingLicense'].fieldSeq}"
                *ngIf=" field_config_access && field_config_access['RES_drivingLicense']">
                <span class="link mat-mt" (click)="openDrivingLicense()" style="font-size: 13px;">
                  {{field_config_access['RES_drivingLicense'].label|| "Driving license"}}
                  <ng-container
                    *ngIf="resumeBankForm.value.drivingLicense && resumeBankForm.value.drivingLicense.length">
                    ({{resumeBankForm.value.drivingLicense.length}})
                  </ng-container>
                </span>
              </div>
              <div
                [class]="field_config_access['RES_nomineeItems'] &&
    field_config_access['RES_nomineeItems'].fieldClass ? field_config_access['RES_nomineeItems'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_nomineeItems'] &&
    field_config_access['RES_nomineeItems'].fieldSeq}"
                *ngIf=" field_config_access &&field_config_access['RES_nomineeItems'] ">
                <span class="link mat-mt" (click)="openNominee()" style="font-size: 13px;">
                  {{ field_config_access &&field_config_access['RES_nomineeItems'].label || "Nominee"}}
                  <ng-container *ngIf="resumeBankForm.value.nomineeItems &&resumeBankForm.value.nomineeItems.length ">
                    ({{resumeBankForm.value.nomineeItems.length}})
                  </ng-container>
                </span>
              </div>
              <div
                [class]="field_config_access['RES_emergencyContacts'] &&
    field_config_access['RES_emergencyContacts'].fieldClass ? field_config_access['RES_emergencyContacts'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_emergencyContacts'] &&
    field_config_access['RES_emergencyContacts'].fieldSeq}"
                *ngIf=" field_config_access &&field_config_access['RES_emergencyContacts'] ">
                <span class="link mat-mt" (click)="openEmergencyContacts()" style="font-size: 13px;">
                  {{ field_config_access &&field_config_access['RES_emergencyContacts'].label || "Emergency
                  contacts"}}
                  <ng-container
                    *ngIf="resumeBankForm.value.emergencyContacts &&resumeBankForm.value.emergencyContacts.length ">
                    ({{resumeBankForm.value.emergencyContacts.length}})
                  </ng-container>
                </span>
              </div>
              <div
                [class]="field_config_access['RES_pickUpPoint'] &&field_config_access['RES_pickUpPoint'].fieldClass ? field_config_access['RES_pickUpPoint'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_pickUpPoint'] &&field_config_access['RES_pickUpPoint'].fieldSeq}"
                *ngIf=" field_config_access &&field_config_access['RES_pickUpPoint']">
                <span class="link mat-mt" (click)="openPickpoint()" style="font-size: 13px;">
                  {{ field_config_access &&field_config_access['RES_pickUpPoint'].label
                  || "Pick up point"}}
                </span>
              </div>

              <div
                [class]="field_config_access['RES_languageData'] &&field_config_access['RES_languageData'].fieldClass ? field_config_access['RES_languageData'].fieldClass :'col-md-4'"
                [ngStyle]="{'order': field_config_access['RES_languageData'] &&field_config_access['RES_languageData'].fieldSeq}"
                *ngIf=" field_config_access &&field_config_access['RES_languageData']">
                <span class="link mat-mt" (click)="openLanguages(1)" style="font-size: 13px;">
                  {{field_config_access['RES_languageData'].label || 'Language proficiency' }}
                  <ng-container
                    *ngIf="resumeBankForm.value.languageData && this.resumeBankForm.value.languageData.length">
                    ({{resumeBankForm.value.languageData.length}})
                  </ng-container>
                </span>

              </div>






            </div>


            <div class="row" style="margin-top:2%"
              *ngIf="field_config_access && field_config_access['RES_presentAddress'] || field_config_access['RES_permanentAddress'] ">

              <div [class]=" !field_config_access['RES_permanentAddress']? 'col-md-12':'col-md-6'" [ngStyle]="{'order': field_config_access['RES_presentAddress'] &&
        field_config_access['RES_presentAddress'].fieldSeq}" *ngIf="field_config_access['RES_presentAddress']">
                <form [formGroup]="presentAddressForm">

                  <div class="card-box-shadow">
                    <div class="card-info-header header">
                      {{field_config_access['RES_presentAddress'].label || 'Present address'}}
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12" *ngIf="field_config_access['RESADD_addressLine1']">
                          <mat-form-field floatLabel="always" class="label-overflow">
                            <mat-label>
                              {{ field_config_access['RESADD_addressLine1'].label
                              ||"OFFER.address_for_communication" | translate }}
                            </mat-label>
                            <input matInput [placeholder]="
                          field_config_access['RESADD_addressLine1'].placeholder||   'OFFER.house_number_and_area' | translate
                            " formControlName="addressLine1" />
                            <mat-error *ngIf="
                              presentAddressForm.controls.addressLine1.hasError(
                                'required'
                              )
                            ">
                              {{ "ERROR.field_is_mandatory" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-md-12" *ngIf="field_config_access['RESADD_addressLine2']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{ field_config_access['RESADD_addressLine2'].label ||"OFFER.commAddressline2"
                              | translate }}
                            </mat-label>
                            <input matInput [placeholder]="
                          field_config_access['RESADD_addressLine2'].placeholder ||'OFFER.enter_street_or_area' | translate
                            " formControlName="addressLine2" />
                            <mat-error *ngIf="
                              presentAddressForm.controls.addressLine2.hasError(
                                'required'
                              )
                            ">
                              {{ "ERROR.field_is_mandatory" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-md-6" *ngIf="field_config_access['RESADD_cityId']">
                          <tm-select [options]="this.timeBasedMaster.cityList || []" [form_group]="presentAddressForm"
                            form_control="cityId" title_property="title" [data]="presentAddressForm.value.cityId"
                            [design_pattern]="4" [label_action_title]="' not found? click here to add'"
                            [label_action_type]="3" [auto_addition]="1" [auto_form_control]="'cityName'"
                            [auto_data]="presentAddressForm.value.cityName"
                            (selected_obj)="presentCityChanged($event,1)"
                            [label]=" field_config_access['RESADD_cityId'].label ||'OFFER.commCityId' | translate"
                            id_property="id" float_label="always"
                            [placeholder]=" field_config_access['RESADD_cityId'].placeholder|| '<- - Select - ->' | translate">
                          </tm-select>
                        </div>
                        <div class="col-md-6" *ngIf="field_config_access['RESADD_stateId']">
                          <tm-select [options]="this.timeBasedMaster.stateList || []" [auto_addition]="1"
                            [auto_form_control]="'stateName'" [auto_data]="presentAddressForm.value.stateName"
                            [design_pattern]="4" [label_action_title]="' not found? click here to add'"
                            [label_action_type]="3" [data]="presentAddressForm.value.stateId"
                            [form_group]="presentAddressForm" form_control="stateId" title_property="title"
                            id_property="id" float_label="always"
                            [placeholder]="field_config_access['RESADD_stateId'].placeholder ||'<- - Select - ->' | translate"
                            [label]="field_config_access['RESADD_stateId'].label ||'OFFER.commStateId' | translate">
                          </tm-select>
                        </div>
                        <div class="col-md-6" *ngIf="field_config_access['RESADD_countryId']">
                          <tm-select [options]="this.masters.countryList || []" [auto_addition]="1"
                            [auto_form_control]="'countryName'" [auto_data]="presentAddressForm.value.countryName"
                            [design_pattern]="4" [label_action_title]="' not found? click here to add'"
                            [label_action_type]="3" [data]="presentAddressForm.value.countryId"
                            [form_group]="presentAddressForm" form_control="countryId" title_property="name"
                            id_property="dial_code" float_label="always"
                            [placeholder]="field_config_access['RESADD_countryId'].placeholder|| '<- - Select - ->' | translate"
                            [label]="field_config_access['RESADD_countryId'].label || 'OFFER.commCountryId' | translate">
                          </tm-select>
                        </div>
                        <div class="col-md-6" *ngIf="field_config_access['RESADD_postalCode']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{ field_config_access['RESADD_postalCode'].label ||"OFFER.commPostalCode" |
                              translate }}
                            </mat-label>
                            <input matInput formControlName="postalCode" [placeholder]="
                          field_config_access['RESADD_postalCode'].placeholder ||   'Enter postal code' | translate
                            " />
                            <mat-error *ngIf="
                              presentAddressForm.controls.postalCode.hasError(
                                'required'
                              )
                            ">
                              {{ "ERROR.field_is_mandatory" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-md-12" *ngIf="field_config_access['RESADD_attachments']">
                          <tm-files-v2 [form_group]="presentAddressForm" [form_control]="'attachments'"
                            [result]="presentAddressForm.value.attachments"
                            [label]="field_config_access['RESADD_attachments'].label ||'OFFER.commAddressProofAtt' | translate"
                            [multiple]="0">
                          </tm-files-v2>
                        </div>
                      </div>
                    </div>

                  </div>
                </form>

              </div>
              <div class="col-md-6" *ngIf="field_config_access['RES_permanentAddress']" [ngStyle]="{'order': field_config_access['RES_permanentAddress'] &&
            field_config_access['RES_permanentAddress'].fieldSeq}"
                [class]="!field_config_access['RES_presentAddress']? 'col-md-12':'col-md-6'">
                <form [formGroup]="permanentAddressForm">

                  <div class="card-box-shadow">
                    <div class="card-info-header header">
                      {{field_config_access['RES_permanentAddress'].label || 'Permanent address'}}
                      <span class="mx-1 link float-right " *ngIf="field_config_access['RES_presentAddress']"
                        style="font-style: italic;color:white" (click)="copyAddress()">
                        {{
                        field_config_access['RES_presentAddress'].label
                        ?'Copy '+field_config_access['RES_presentAddress'].label :
                        "OFFER.copy_communication_address" | translate
                        }}
                      </span>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12" *ngIf="field_config_access['RESADD_addressLine1']">
                          <mat-form-field floatLabel="always" class="label-overflow">
                            <mat-label style="pointer-events: all; cursor: pointer">
                              {{ field_config_access['RESADD_addressLine1'].label
                              ||"OFFER.permanent_address" | translate }}

                            </mat-label>
                            <input matInput [placeholder]=" field_config_access['RESADD_addressLine1'].placeholder ||'OFFER.house_number_and_area' | translate
                              " formControlName="addressLine1" />
                            <mat-error *ngIf="
                                permanentAddressForm.controls.addressLine1.hasError(
                                  'required'
                                )
                              ">
                              {{ "ERROR.field_is_mandatory" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-md-12" *ngIf="field_config_access['RESADD_addressLine2']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{ field_config_access['RESADD_addressLine2'].label ||"OFFER.street_or_area" |
                              translate }}
                            </mat-label>
                            <input matInput [placeholder]=" field_config_access['RESADD_addressLine2'].placeholder|| 'OFFER.enter_street_or_area' | translate
                              " formControlName="addressLine2" />
                            <mat-error *ngIf="
                                permanentAddressForm.controls.addressLine2.hasError(
                                  'required'
                                )
                              ">
                              {{ "ERROR.field_is_mandatory" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-md-6" *ngIf="field_config_access['RESADD_cityId']">
                          <tm-select [options]="this.timeBasedMaster.cityList || []" [form_group]="permanentAddressForm"
                            form_control="cityId" title_property="title" [data]="permanentAddressForm.value.cityId"
                            [design_pattern]="4" [label_action_title]="' not found? click here to add'"
                            [label_action_type]="3" [auto_addition]="1" [auto_form_control]="'cityName'"
                            [auto_data]="permanentAddressForm.value.cityName"
                            (selected_obj)="presentCityChanged($event,2)"
                            [label]="field_config_access['RESADD_cityId'].label ||'OFFER.commCityId' | translate"
                            id_property="id" float_label="always"
                            [placeholder]="field_config_access['RESADD_cityId'].placeholder ||'<- - Select - ->' | translate">
                          </tm-select>
                        </div>
                        <div class="col-md-6" *ngIf="field_config_access['RESADD_stateId']">
                          <tm-select [options]="this.timeBasedMaster.stateList || []" [auto_addition]="1"
                            [auto_form_control]="'stateName'" [auto_data]="permanentAddressForm.value.stateName"
                            [design_pattern]="4" [label_action_title]="' not found? click here to add'"
                            [label_action_type]="3" [data]="permanentAddressForm.value.stateId"
                            [form_group]="permanentAddressForm" form_control="stateId" title_property="title"
                            id_property="id" float_label="always"
                            [placeholder]=" field_config_access['RESADD_stateId'].placeholder || '<- - Select - ->' | translate"
                            [label]=" field_config_access['RESADD_stateId'].label ||  'OFFER.commStateId' | translate">
                          </tm-select>
                        </div>
                        <div class="col-md-6" *ngIf="field_config_access['RESADD_countryId']">
                          <tm-select [options]="this.masters.countryList || []" [auto_addition]="1"
                            [auto_form_control]="'countryName'" [auto_data]="permanentAddressForm.value.countryName"
                            [design_pattern]="4" [label_action_title]="' not found? click here to add'"
                            [label_action_type]="3" [data]="permanentAddressForm.value.countryId"
                            [form_group]="permanentAddressForm" form_control="countryId" title_property="name"
                            id_property="dial_code" float_label="always"
                            [placeholder]=" field_config_access['RESADD_countryId'].placeholder ||'<- - Select - ->' | translate"
                            [label]=" field_config_access['RESADD_countryId'].label ||'OFFER.commCountryId' | translate">
                          </tm-select>
                        </div>
                        <div class="col-md-6" *ngIf="field_config_access['RESADD_postalCode']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{ field_config_access['RESADD_postalCode'].label ||"OFFER.permPostalCode" |
                              translate }}
                            </mat-label>
                            <input matInput formControlName="postalCode" [placeholder]="
                          field_config_access['RESADD_postalCode'].placeholder ||'Enter postal code' | translate
                              " />
                            <mat-error *ngIf="
                                permanentAddressForm.controls.postalCode.hasError(
                                  'required'
                                )
                              ">
                              {{ "ERROR.field_is_mandatory" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-md-12" *ngIf="field_config_access['RESADD_attachments']">
                          <tm-files-v2 [form_group]="permanentAddressForm" [form_control]="'attachments'"
                            [result]="permanentAddressForm.value.attachments"
                            [label]="field_config_access['RESADD_attachments'].label || 'OFFER.permAddressProofAtt' | translate"
                            [multiple]="0">
                          </tm-files-v2>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

              </div>



            </div>
            <div class="col-md-12" style="margin-top:2%">
              <div class="row">
                <div
                  [class]="field_config_access['RES_cvRating'] &&
              field_config_access['RES_cvRating'].fieldClass ? field_config_access['RES_cvRating'].fieldClass :'col-md-6'"
                  [ngStyle]="{'order': field_config_access['RES_cvRating'] &&
              field_config_access['RES_cvRating'].fieldSeq}"
                  *ngIf="field_config_access &&field_config_access['RES_cvRating']">
                  <label class="d-block m-0" for="" style="font-size: 12px;
                                           color: black; font-weight: 500; opacity: .9;">{{
                    field_config_access['RES_cvRating'].label || 'RESUME.resumeRating'
                    |translate}}
                    <span (click)="openGuideline()" class="cursor pointer" style="font-size: 14px;color: red;">
                      <i style="font-weight: bold;" class="fa fa-question-circle ">
                        {{ 'RESUME.ratingGuideline' |translate}}
                      </i>
                    </span>
                  </label>
                  <div style="position: relative;">
                    <mat-star-rating [rating]="cv_rating" [starCount]="starCount" [color]="starColor"
                      (ratingUpdated)="onCandidateRatingChanged($event)">
                    </mat-star-rating>
                    <span class="ml-2" style="font-size: 14px;position:absolute;top:11px;">
                      {{cv_rating_title}}
                    </span>
                  </div>
                </div>
                <!-- <div class="col-md-4">
                <span (click)="openGuideline()" class="cursor"
                  style="font-size: 14px;position:absolute;top:28px;color: red;">
                  <i style="font-weight: bold;" class="fa fa-question-circle ">
                    {{'RESUME.ratingGuideline' |translate}} </i>
                </span>
              </div> -->
                <div
                  [class]="field_config_access['RES_commSkillRating'] &&
              field_config_access['RES_commSkillRating'].fieldClass ? field_config_access['RES_commSkillRating'].fieldClass :'col-md-6'"
                  [ngStyle]="{'order': field_config_access['RES_commSkillRating'] &&
              field_config_access['RES_commSkillRating'].fieldSeq}"
                  *ngIf="field_config_access &&field_config_access['RES_commSkillRating']">
                  <label class="d-block m-0" for="" style="font-size: 12px;
                                            color: black; font-weight: 500; opacity: .9;">{{
                    field_config_access['RES_commSkillRating'].label || 'RESUME.ratingCommunicationSkills'
                    |translate}}
                    <span (click)="openGuidelineCommunication()" class="cursor pointer"
                      style="font-size: 14px;color: red;">
                      <i style="font-weight: bold;" class="fa fa-question-circle ">
                        {{ 'RESUME.ratingGuideline'
                        |translate}}
                      </i>
                    </span>
                  </label>
                  <div style="position: relative;">
                    <mat-star-rating [rating]="comm_rating" [starCount]="starCount" [color]="starColor"
                      (ratingUpdated)="commRating($event)">
                    </mat-star-rating>
                    <span class="ml-2" style="font-size: 14px;position:absolute;top:11px;">
                      {{comm_rating_title}}

                    </span>
                  </div>
                </div>
              </div>
            </div>
            <hr style="margin-top: 0px !important;"
              *ngIf="resumeBankForm.value.extendedData && resumeBankForm.value.extendedData.length">
            <div class="row" *ngIf="resumeBankForm.value.extendedData && resumeBankForm.value.extendedData.length">
              <div class="col-md-12">
                <h6> Extended info. </h6>
              </div>
            </div>
            <ng-container *ngIf="resumeBankForm.value.extendedData && resumeBankForm.value.extendedData.length">
              <app-ext-fields [form_group]="resumeBankForm" [form_control]="'extendedData'"
                [masters]="this.masters.extendedMasterList" [data]="resumeBankForm.value.extendedDataUI">
              </app-ext-fields>
            </ng-container>

            <div class="row pt-3">
              <div class="col-md-12 text-right">
                <button style="min-width: 100px;" class="ml-auto btn-sm blob-btn-cancel btn mx-1 mx-1 tallite-action"
                  matStepperPrevious (click)="previousStep(stepper)">
                  {{ 'BTN.previous' | translate}}
                  <span class="blob-btn-cancel__inner">
                    <span class="blob-btn-cancel__blobs">
                      <span class="blob-btn-cancel__blob"></span>
                      <span class="blob-btn-cancel__blob"></span>
                      <span class="blob-btn-cancel__blob"></span>
                      <span class="blob-btn-cancel__blob"></span>
                    </span>
                  </span>
                </button>
                <button style="min-width: 100px;" class="blob-btn  btn btn-sm   mx-1 tallite-action"
                  (click)="saveResume()" type="submit">
                  {{ 'BTN.submit' | translate }}
                  <span class="blob-btn__inner">
                    <span class="blob-btn__blobs">
                      <span class="blob-btn__blob"></span>
                      <span class="blob-btn__blob"></span>
                      <span class="blob-btn__blob"></span>
                      <span class="blob-btn__blob"></span>
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </form>
        </ng-template>

      </mat-step>
    </mat-stepper>

  </div>
</div>
<!-- <button mat-button matStepperPrevious>Back</button>
<button mat-button matStepperNext>Next</button> -->
<div class="camera" id='camera'>
  <video id="video"></video>
  <span class="btn-container">
    <button class="btn btn-sm js-btn-cancel mx-1" id="cancelButton">{{"BTN.cancel"|translate}}</button>
    <button id="startbutton" class="btn btn-sm js-btn-save mx-1">{{"EXTRA.Take photo"|translate}}</button>
  </span>
</div>

<ng-container *ngIf="resumeBankForm.controls">
  <ng-container *ngFor="let control of Object.keys(resumeBankForm.controls) ">
    <span class="d-none"> {{ resumeBankForm.get([control]).value | DynamicFieldConfigProcessing : resumeBankForm :
      control:original_field_config_access : field_config_access : 'RES_' :validators : change_detector}} </span>
  </ng-container>
</ng-container>

<ng-container *ngIf="registrationForm.controls">
  <ng-container *ngFor="let control of Object.keys(registrationForm.controls) ">
    <span class="d-none"> {{ registrationForm.get([control]).value | DynamicFieldConfigProcessing : registrationForm :
      control:original_field_config_access : field_config_access : 'RES_' :validators : change_detector}} </span>
  </ng-container>
</ng-container>

<ng-container *ngIf="educationForm.controls">
  <ng-container *ngFor="let control of Object.keys(educationForm.controls) ">
    <span class="d-none"> {{ educationForm.get([control]).value | DynamicFieldConfigProcessing : educationForm :
      control:original_field_config_access : field_config_access : 'RES_' :validators : change_detector}} </span>
  </ng-container>
</ng-container>
<ng-container *ngIf="educationForm2.controls">
  <ng-container *ngFor="let control of Object.keys(educationForm2.controls) ">
    <span class="d-none"> {{ educationForm2.get([control]).value | DynamicFieldConfigProcessing : educationForm2 :
      control:original_field_config_access : field_config_access : 'RES_' :validators : change_detector}} </span>
  </ng-container>
</ng-container>
<ng-container *ngIf="educationForm3.controls">
  <ng-container *ngFor="let control of Object.keys(educationForm3.controls) ">
    <span class="d-none"> {{ educationForm3.get([control]).value | DynamicFieldConfigProcessing : educationForm3 :
      control:original_field_config_access : field_config_access : 'RES_' :validators : change_detector}} </span>
  </ng-container>
</ng-container>
